<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align:center"></div>
<h1 id="pgepubid00000">
<br/>
<br/>
  An Awfully Big<br/>
  Adventure<br/>
</h1>
<p><br/>
</p>
<p class="t3">
  BY<br/>
</p>
<p class="t2">
  "BARTIMEUS"<br/>
</p>
<p><br/>
</p>
<p class="t3">
  CASSELL AND COMPANY, LTD<br/>
  London, New York, Toronto and Melbourne<br/>
</p>
<p><br/>
<br/>
<br/>
</p>
<p class="t4">
First published 1919
</p>
<p><br/>
<br/>
<br/>
</p>
<p class="t3">
  To<br/>
  A. R. S.<br/>
</p>
<p><br/>
<br/>
<br/>
</p>
<p class="t3b">
NOTE
</p>
<p class="noindent" style="margin-left: 10%; margin-right: 10%">
<i>The sketch entitled "Unto the Hills" appeared
originally in</i> Blackwood's Magazine, <i>and is
included in this book with the Editor's kind
permission.</i>
</p>
<p><br/>
<br/>
<br/>
</p>
<p class="t3b">
PREFACE
</p>
<p>
It was my original intention to gather this
miscellaneous assortment of war sketches and stories
together under the heading of "A Scran Bag."
</p>
<p>
The aptness of this title will be apparent when it is
explained that odds and ends of personal possessions
left lying about the mess decks of a man-of-war are
impounded by the Ship's Police and kept for safe
custody in a sack.  This receptacle of random
gleanings is called the Scran Bag.
</p>
<p>
My publishers agreed that the title was admirable—to
the initiated.  They opined, however, that the
bulk of the public would be left, so to speak, cold.
They reminded me that it was no use explaining it in
a Preface, since no one reads Prefaces.  They intimated
that life was a sordid business, and we all have
to make our livings—in short, no book with such a
title would sell.
</p>
<p>
I therefore turned to the classics, and in "Peter
Pan" found a title which, I think, is comprehensive
of any record, however fragmentary and incomplete,
whether bald fact or fact sugared with fiction, of the
Navy's share in this War.
</p>
<p>
"To die," said Peter Pan, "would be an awfully
big adventure." It may be so; but, unhappily, the
lips of the adventurer are sealed, and we are left
theorising, none the wiser.
</p>
<p>
To wake up in the morning is a better thing than
dying, for all the poets may say; and if the day holds,
as this book does, somewhat of love, war in a
righteous cause, and victory at its close, may not it,
too, be called An Awfully Big Adventure?
</p>
<p><br/>
<br/>
<br/>
</p>
<p class="t3b">
CONTENTS
</p>
<p><br/>
</p>
<p class="t3">
I
</p>
<p class="noindent" style="font-weight: bold">
An Awfully Big Adventure.
</p>
<p class="noindent">
    1. <a class="pginternal" href="#/4135519329222943696_73819h0.htm#chap01a">THE WOOING OF MOULDY JAKES</a>
</p>
<p class="noindent">
    2. <a class="pginternal" href="#/4135519329222943696_73819h0.htm#chap01b">THE NARRATIVE OF COMMANDER WILLIAM
DALRYMPLE HORNBY, ROYAL NAVY</a>
</p>
<p><br/>
</p>
<p class="t3">
II
</p>
<p class="noindent" style="font-weight: bold">
Behind the Veil: The Story of the Q Boats. (1918)
</p>
<p class="noindent">
    1. <a class="pginternal" href="#/4135519329222943696_73819h0.htm#chap0201">FIRST BLOOD</a>
</p>
<p class="noindent">
    2. <a class="pginternal" href="#/4135519329222943696_73819h0.htm#chap0202">ORDEAL BY FIRE</a>
</p>
<p class="noindent">
    3. <a class="pginternal" href="#/4135519329222943696_73819h0.htm#chap0203">WON BY WAITING</a>
</p>
<p class="noindent">
    4. <a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap0204">THE SPLENDID FAILURE</a>
</p>
<p><br/>
</p>
<p class="t3">
III
</p>
<p class="noindent" style="font-weight: bold">
"Not in the Presence of the Enemy." (1918)
</p>
<p class="noindent">
    1. <a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap0301">THE GLEANER</a>
</p>
<p class="noindent">
    2. <a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap0302">THE MILLIONTH CHANCE</a>
</p>
<p class="noindent">
    3. <a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap0303">CHINKS</a>
</p>
<p class="noindent">
    4. <a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap0304">A FORTY-FOOT SETTING</a>
</p>
<p><br/>
</p>
<p class="t3">
IV
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap04">The Action between H.M.S. <i>Prize</i> and German
Submarine U93</a>
</p>
<p><br/>
</p>
<p class="t3">
V
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap05">The Forfeit (1916)</a>
</p>
<p><br/>
</p>
<p class="t3">
VI
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap06">Supper Beer (1914)</a>
</p>
<p><br/>
</p>
<p class="t3">
VII
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap07">The Way They Have (1915)</a>
</p>
<p><br/>
</p>
<p class="t3">
VIII
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap08">The Epitaph</a>
</p>
<p><br/>
</p>
<p class="t3">
IX
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap09">The English Way (1917)</a>
</p>
<p><br/>
</p>
<p class="t3">
X
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap10">The Parting of the Ways (1919)</a>
</p>
<p><br/>
</p>
<p class="t3">
XI
</p>
<p class="noindent" style="font-weight: bold">
<a class="pginternal" href="#/4135519329222943696_73819h1.htm#chap11">Unto the Hills (1913)</a>
</p>
<p><br/>
<br/>
<br/>
</p>
<p><a id="chap01a"></a></p>
<p class="t2">
AN AWFULLY BIG ADVENTURE
</p>
<p><br/>
<br/>
</p>
<h2 id="pgepubid00001">
PART ONE
</h2>
<h3 id="pgepubid00002">
THE WOOING OF MOULDY JAKES
</h3>
<p class="t3">
1
</p>
<p>
The late afternoon sunlight was slanting across the
heather when the "Mantis" came puffing round a
bend of the river.
</p>
<p>
Contrary to the established custom and traditions
of British men-of-war, her crew maintained a breathless
and high-spirited dialogue with the Captain, who
seasoned it with shrill invective directed at a routed
enemy, invisible and presumed to be in full flight
amid the bracken.
</p>
<p>
At the bend alluded to, the Captain of the
"Mantis" turned and shouted encouragement to the
"Moth," who, some hundred yards astern, was
negotiating some rapids and presumably under
heavy fire.
</p>
<p>
"I say, <i>do</i> buck up!" he cried.  "The Turks are
retreating like anything!"
</p>
<p>
"I can't buck up," wailed the Captain, officers and
ship's company of the "Moth."  "There's a bramble
all caught up in my petticoat."
</p>
<p>
"Take the beastly thing off then," commanded the
Senior Officer, and turned to con his ship through the
tortuous shallows of the Upper Reaches.
</p>
<p>
The fir-clad and boulder-strewn slopes of the valley
had given place to the open moor, where the stream
abandoned its headlong course and broadened into
wide pools and shelving beaches of gravel strewn with
bleached twigs.
</p>
<p>
The "Tarantula" was discernible still among the
cataracts, while in the far distance the Main Army
clambered deftly from boulder to boulder and fended
off the onslaughts of flies with a frond of bracken.
</p>
<p>
Although the fire of the enemy had perceptibly
slackened, the casualties aboard the "Mantis" mounted
steadily.  Three times the Commanding Officer quitted
his ship to wallow in his gore on the springy turf,
only returning on each occasion to find the Quartermaster
on his knees in the shallows, delivering valedictory
rhetoric at his post as his life's blood ebbed.
</p>
<p>
The barred and speckled trout fled up-stream like
bronze flashes as the irresistible advance continued.
The shrill bark of the "Mantis's" gun searched the
hollows and peat bogs for the possibly lurking rearguard
of the rout, and sent the shy kingfisher darting
ahead of the bedraggled white ensign in the van of
the pursuit.
</p>
<p>
Finally the "Mantis" dropped anchor from sheer
lack of breath and prepared to disembark a landing
party.  Her Captain, carrying the ensign and armed
to the teeth, climbed on to a lichen-scarred boulder in
quest of the remainder of the Naval Forces.
</p>
<p>
"<i>Come</i> on!" he shouted, and the sound of his
voice was swallowed by the vast solitude of the
moor.
</p>
<p>
The "Moth" had forsaken the waterways and from
discreet glimpses afforded by a furze bush bordering
the stream was proceeding in execution of previous
orders.
</p>
<p>
The "Tarantula"—it was useless to disguise the
inglorious fact—was engaged in picking blackberries
and sharing them with the Main Army.  Far out of
reach of hail or reproach, the advance guard of that
historic force, hitherto invisible, was alone unquenched
in spirit and energy, and rushed to and fro with
wagging tail among the bewildering blend of scents left
by the passage of rabbit, vole and otter.
</p>
<p>
The Captain of the "Mantis" permitted his nostril
to curl contemptuously.
</p>
<p>
"Pouf!" he said, and added—for the benefit of the
officers and men of the landing party, desperadoes
all—"what can you expect from girls?"
</p>
<p>
His fellow-desperadoes, presumably from motives
of chivalry or disgust, vouched no reply, and their
leader turned to sweep the path of the retreat through
a pair of mother-of-pearl opera glasses, suspended
from his neck by a piece of string.  Then instinctively,
like a wild animal surprised, all the supple
grace of his young body stiffened tense and rigid.  Not
fifty yards up-stream sat a man nursing a rifle across
his knees.
</p>
<p>
He was a youngish man, clean-shaven, and he sat,
apparently deep in thought, purring a pipe.  Not even
the tumult of the advance upon Bagdad appeared to
have disturbed his reflections, for he had not turned
his head.
</p>
<p>
The Senior Officer of the Naval Forces lowered
his mother-of-pearl opera glasses and scrutinised the
stranger with his unimpeded vision for nearly a
minute.  Finally, casting a glance down-stream,
he clambered from his place of vantage and
advanced.
</p>
<p>
The boy was about ten paces distant when the
stranger turned his head.  He was of a lean, rather
lantern-jawed cast of countenance, and his
reddish-brown eyes showed not the faintest surprise or
curiosity at being suddenly confronted by a small
sunburnt boy, bare-legged and dripping wet, who
wore a brass-hilted sword bayonet (relic of the
Franco-Prussian war), cutlass-wise, a leather pistol holster
(empty), a soda-water bottle, a bandolier made of
corks, and the aforementioned opera glasses all
distributed about his person, and who carried a white
ensign on an ash-plant.
</p>
<p>
"'Evening," said the stranger; the safety catch of
his rifle went over with a little click.
</p>
<p>
The boy stood perfectly still, and there was a
moment's silence.  Then, planting the flagstaff in the
sandy margin of the stream, he came closer.
</p>
<p>
"What's your name?" he inquired.
</p>
<p>
"Jakes," replied the seated figure.  He removed
his pipe from between his teeth and blew meditatively
into the bowl, contemplating the tendril of smoke
issuing from the mouthpiece with the air of an
alchemist preoccupied with a phenomenon.
</p>
<p>
"Graeme Jakes," he added in a lower tone, as if
speaking to himself.  "Sometimes called 'Mouldy.'
</p>
<p>
"Mine's Cornelius James Halliday," volunteered
the boy.  Whatever he read in the stranger's face
apparently banished the lurking fear of ridicule
from his sensitive and imaginative heart.  "I'm the
'Mantis,' you know," he continued, "coming up the
river to Bagdad.  The 'Moth' and 'Tarantula' are
away back in there——"  He jerked his hand towards
the bend in the stream as if the gesture made the
explanation quite clear and sufficing.
</p>
<p>
The man evinced no apparent surprise at the
information; he replaced his pipe between his teeth,
took a couple of deep puffs at it and nodded gravely:
</p>
<p>
"What about the Army?" he asked.
</p>
<p>
"Oh, she—it's back there too.  Miss Mayne's the
Army.  She's our governess, and her brother was killed
in the retreat from Mons, so we always let her be the
Army.  He was in the Guards, and she only cried
once; she'd be here now only Georgie—Georgina,
you know, my sister—made her stop and pick
blackberries.  Georgina swanks rather nowadays when we
have games—she usen't to, but she's getting old.
Jane doesn't swank, only she got foul of some
brambles, and she's coming on in her knickerbockers
when she's got her skirt off."
</p>
<p>
The dilatory advance of the remainder of the
British Expeditionary Force having been
satisfactorily explained, Cornelius James sat down and
clasped his hands about his small scarred knees.  His
eyes were drawn and held by the magnetism of
the lethal weapon which lay idly upon the man's
knees.
</p>
<p>
"Is that loaded?" he queried.
</p>
<p>
"Yep."
</p>
<p>
"What do you shoot with it—mostly—hereabouts?"
</p>
<p>
From his tone the conversation might have been
conducted in a country where tiger predominated
among the fauna.
</p>
<p>
"Rabbits," replied the other, adding after a pause:
"sitting."  He jerked open the breech of the miniature
rifle, picked up the tiny shell that flicked out on to the
turf and handed it gravely to his interrogator.
</p>
<p>
Cornelius James accepted it with equal gravity.
</p>
<p>
"Hullo!"  he exclaimed.  "What's up with your
hand?  Why is it all bandaged?  Have you been
wounded in the war?"
</p>
<p>
Graeme Jakes surveyed the grubby folds of lint
and the maimed fingers of his left hand.  For the first
time the shadow of a smile played about his mouth.
</p>
<p>
"Yep.  Long time ago.  Nothin' much, only it
wouldn't heal.  Went bad on me.  Bit of poison gas
shell."
</p>
<p>
"Oh," said the boy, and contemplated his new
acquaintance with renewed interest.
</p>
<p>
"Are you Army or Navy?"
</p>
<p>
The man slid a cartridge into his rifle, closed the
bolt and raised the weapon to his shoulder, resting his
left elbow on his knee.  A sharp report followed the
instant's silence; the scut of a rabbit flicked white on
the opposite slope and vanished.
</p>
<p>
"Missed him!" ejaculated the sniper.  "Generally do."
</p>
<p>
He lowered the toy on to his knees again.  "Navy,"
he continued as if nothing had interrupted the
conversation.
</p>
<p>
"Daddy's in the Navy too," exclaimed the boy.
"Do you know him?—he's an Admiral."
</p>
<p>
"Know him by name.  Don't bump up against
Admirals much."
</p>
<p>
"I wish I was old enough to be in the Navy,"
sighed Cornelius James.  "It's awful not being able to
do anything in this war.  Even Miss Mayne is going
to do war work soon.  She says every woman ought
to do something."
</p>
<p>
"Who—who's Miss Mayne?"
</p>
<p>
"I told you.  Our governess.  She's a perfect
ripper.  She's the third governess we've had.  But
the other two weren't quite——"  Cornelius James
hesitated.  "Well's matter of fact, I don't think they
were quite the right sort.  They didn't understand
how to play, they hadn't any 'magination, and they
were always afraid of cows and getting sunburnt and
taking off their shoes and stockings when it came to
anything wet.  Miss Mayne's quite different—because—well,
because she's what she is, I suppose.  It makes
all the difference, doesn't it?"
</p>
<p>
Graeme Jakes considered the subtlety in silence.
</p>
<p>
"I don't know," he said finally.  He turned his
head and looked at the small snob nursing his bare
knees.  Again their eyes met in friendly searching
scrutiny.
</p>
<p>
"I've hardly ever met any ladies," he said.  It was
as if he had taken the boy as an equal into a rather
pathetic confidence.
</p>
<p>
Cornelius James surveyed his new friend with a
deliberate interest.  It absorbed the frayed deerstalker
speckled with trout-flies, the flannel shirt open at the
throat, the baggy tweed coat of many pockets, the
corduroy breeches and muddy boots and gaiters.  To
the wearer of these garments he applied in turn all
the standards of his brief experience of life.
</p>
<p>
"Don't they like you?" he asked.
</p>
<p>
"Dunno," was the reply.  "Never asked 'em."  He
looked musingly across the rolling moor.  "One
did once—but she died when I was little."
</p>
<p>
The splashing of water down-stream interrupted
the speaker.
</p>
<p>
"Here's Jane," said Cornelius James, looking over
his shoulder.  "She's all right," he added, quickly, as
the other made a hasty movement that suggested
fright.  "She's really quite sensible for a girl."
</p>
<p>
Jane drew near, swinging her broad-brimmed hat
in her hand and stepping from stone to stone with
the lithe grace of a youthful dryad.  She had
discarded her petticoat and wore only a jersey and
knickers.
</p>
<p>
"Jane," shouted Cornelius James, as she
approached.  "He's in the Navy, but he doesn't know
Daddy."  He made a gesture of proprietorship in the
direction of the impassive figure seated in the heather.
</p>
<p>
Jane waded ashore and extended her hand with
friendly unconsciousness of self.
</p>
<p>
"How d'you do?" she said, and devoured him
with round grey eyes.  "Did you ever know
Mr. Standish?" she inquired.
</p>
<p>
Her brother's protégé nodded smiling.  "Bunje?"
he said.  "Yes, rather—I was shipmates along of Jim."
</p>
<p>
He lapsed jestingly into the vernacular of the
lower deck.
</p>
<p>
"Jane loves him," interposed Cornelius James.
"She was going to marry him only he got married to
someone else.  She was awfully sick—weren't you,
Jane?"
</p>
<p>
"Shut up," was the graceful retort of the woman
scorned.  "And did you know Torps—Mr. Mainwaring?
He was killed," she added gravely.
</p>
<p>
"No, never shipmates with him.  Heard about
him, though.  White man by all accounts."
</p>
<p>
"He was a darling," said Jane, simply.  "It's
dreadful to think of him dead.  But I don't think
frightfully nice people <i>really</i> die, do you?"
</p>
<p>
"Don't know any," was the solemn reply.
</p>
<p>
Jane pursed up her mouth and opened her eyes
wider.  She was standing upright as a lath before
him, her hands clasped behind her, and the water still
glistened on her slim bare legs.
</p>
<p>
"Where do you live?" she inquired, compassionately.
The stranger jerked his head back across
the moor to where the ground rose and the façade of a
distant mansion was discernible through a vista in the
trees of a great park.
</p>
<p>
"Over there," he added in amplification.
</p>
<p>
"Does that house belong to you?" asked Jane
all incredulous.  She had decided at the first glimpse
that this was a homeless tramp of the cleaner
and rather nice variety, and from the first had
been prepared to take him, metaphorically, to her
bosom.
</p>
<p>
"No," said the tramp.  "It's my brother-in-law's
place.  I stay with him and my step-sister when I'm
ashore."  He eyed the children in turn.  "Where do
you live?"
</p>
<p>
"We live ever so far away," replied Cornelius
James.  "But we've all had chicken-pox and we've
come with Miss Mayne to stay in a farm near here.
Glebe Farm it's called.  Mummie's up in Scotland——"
</p>
<p>
"So's to be near Daddy's ship," explained Jane.
</p>
<p>
"Will you come and have tea with us one day?"
added the boy.  "You needn't be frightened, 'cos
we've stopped peeling and we're out of quarantine.
Do you know where Glebe Farm is?"
</p>
<p>
The other nodded.  "Belongs to my brother-in-law,"
he said.  His eyes as he spoke were on the lower
reaches of the river.  Then abruptly he rose to his
feet.  "Now I must be off," he said.  "Awfully
important engagement."
</p>
<p>
At the bend of the river Miss Mayne and Georgina
stood shading their eyes from the sun.
</p>
<p>
"Oh, don't go!" chorused Jane and her brother.
"You haven't talked to Miss Mayne yet," added
Cornelius James—"or Georgina.  She'll run after you
when she knows you're in the Navy, so it's no use
going yet——Hallo!"  He broke off and stared
downstream.  "Now where's Miss Mayne off to?"
</p>
<p>
"Gone to put her stockings on," explained Jane,
with the mysterious comprehension of sex.  "She's
shy."
</p>
<p>
"Pouf!" snorted Cornelius James.  "Miss Mayne shy!"
</p>
<p>
"Must be off," muttered Mr. Jakes with a swift
glance at the far-off clump of gorse that concealed
Miss Mayne and her modesty.  "Just remembered
most important engagement——"  He extended his
hand to each of his small acquaintances, and, turning
abruptly, made off across the moor with his shadow
stalking jerkily ahead of him.
</p>
<p>
"Nice man!" was Jane's emphatic conviction.
</p>
<p>
Cornelius James eyed his sister with suspicion.
</p>
<p>
"Now look here, Jane," he said, "<i>I</i> found this
man.  Just remember that.  You bagged the shepherd
in the little house on wheels, an' that boy who could
imitate a bullfinch, and the man with the wooden leg
at the level crossing.  I found them first and I found
this man first.  He's mine."
</p>
<p>
"Here's Miss Mayne," replied his sister.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
2
</p>
<p>
Graeme Jakes found his step-sister in the hall on
his return.  He laid his rifle down, and, crossing over
to the fireplace, stood eyeing her with his back to the
empty hearth.
</p>
<p>
The evening post had been brought in and the
surface of the sofa not occupied by the lady's angular
form was strewn with opened envelopes, charitable
appeals, receipted bills, and a sprinkling of letters.
Lady Manners was a woman approaching forty, clad
in garments of aggressively country cut, and about
her obtrusively brogued feet a collection of
dachshunds squirmed and writhed.
</p>
<p>
She looked up from her correspondence and
scrutinised her brother through tortoiseshell-rimmed
spectacles.
</p>
<p>
"Where have you been all the afternoon?" she
inquired.  "The Smedleys were over to tea."
</p>
<p>
"Those people who bought The Garth?"
</p>
<p>
"Yes.  Mrs. Smedley brought her two girls
expressly to renew their acquaintance with you.  And
you—you vanish!"
</p>
<p>
Lady Manners picked up another envelope and
slit it open with an action somehow suggestive of a
hard-pressed fishmonger gutting herrings.
</p>
<p>
"I've had some," was the reply.
</p>
<p>
"Had what—tea?"
</p>
<p>
"No, Mrs. Smedley's girls.  The Misses Smedley."
</p>
<p>
"I don't know that I quite follow you, Graeme.
Do you mind not knocking out your pipe on the clean
hearth?"
</p>
<p>
The individual addressed ignored the last sentence
and thoughtfully rubbed the bowl of his pipe against
the side of his sunburnt nose.
</p>
<p>
"They give me the holy pip," he explained.
</p>
<p>
"Do they!" said his step-sister icily.  "May I
ask in what respect they—they fail to meet with your
approval?  You are fond of complaining that you
never meet any nice girls—that your life in the Navy
restricts you to the companionship of your own sex;
with an alternative the reverse of desirable.  I place
opportunities in your way of becoming acquainted
with the young people of the County and you behave
with rudeness to them, and to me, if you'll let me say
so.  Josephine and Alicia Smedley are both
war-workers, and you should have much in common,
making all allowances for your—er, peculiar
upbringing."
</p>
<p>
"Thank 'ee," said her step-brother cheerfully.
"What particular line of business do they chuck their
weights about in?"
</p>
<p>
"They are both taking a holiday, but normally
Josephine drives a War Office car——"
</p>
<p>
"Abnormally, I should say," interposed the soiler
of clean hearths.  "She's got a laugh like a Klaxon
horn.  What's t'other been doing in the Great War,
Grannie?"
</p>
<p>
"Alicia?  She places her somewhat exceptional
talents at the disposal of the wounded
soldiers—officers, of course."
</p>
<p>
"Course.  Don't tell me she nurses 'em?"
</p>
<p>
"No.  Her temperament—sensitive, artistic, fluid
as it is—is too refined for the horrors of wards and
operating theatres; she dances to amuse the poor
things when they are convalescing—convalescence is
a trying time."
</p>
<p>
"It is.  Did she come over to give a display for my
benefit?  I'm only a wounded sailor, though.  Don't
count, I s'pose?"
</p>
<p>
Lady Manners began to gather her correspondence
together.
</p>
<p>
"Graeme," she said, "I am at a loss to know why
you should adopt this tone.  If it is intended to be in
keeping with a pose which your profession requires
of you, I can only say that it ill becomes a guest
before this hearth."
</p>
<p>
There was a genuinely hurt tone in the lady's
voice—which, indeed, trembled a little.  This note of
unconscious pathos moved Graeme to one of his rare
attempts at self-revelation.  He knew she was fond of
him in her preoccupied, hard way, and was more
concerned about his "lone wolf" attitude towards the
amenities of civilised life, as she understood them,
than she was capable of putting into words.
</p>
<p>
"Emily," he said, "'tisn't a pose.  'Fore God it's
no pose.  Call me what you like—intolerant, idealistic,
or whatever long word meets my case.  Fact remains,
I can't stick that type of woman.  They shock me,
Emily, in the way blasphemy and drunkenness shock
you.  All my life long—for fifteen years at
least—I've lived in ships with men as my sole
companions—raucous-voiced, hairy-chested, buck men,
my dear; every blessed type; selfish men and unselfish
ones, drunkards, bullies, cranks, wise men and fools.
'Tisn't that one doesn't like 'em at heart, most of 'em.
Some are lovable; but one gets into the way of
thinking women must be somehow utterly different.  When
I went to sea I thought all women in the world must
be like what I could remember of Mother—" unconsciously
his voice changed.  "I went on thinking so
for some years, chiefly because I never met any women
to speak to.  The more I saw of men the more I felt
convinced that women must be wonderful ... their
voices..."
</p>
<p>
The speaker pulled out a ragged tobacco pouch
and slowly fell to filling his pipe.
</p>
<p>
"Course, as time went on I met women—of a sort—but
they didn't disillusion me.  They strengthened
my conviction that the—er—other sort must be all
I'd dreamed they were.  Trouble was I never met any.
I haven't any parlour tricks—too shy——"
</p>
<p>
For a few moments the lighting of his pipe occupied
the speaker's attention.  He enveloped himself in
wreaths of smoke.
</p>
<p>
"I wonder why—I wonder how girls—ladies, I
mean, to use an old-fashioned word—get like that
Josephine Smedley; flicking cigarette ash about and
grimacing when they talk.  They don't seem able to
say anything without George Robey's slang to help
'em, or to finish a sentence without a laugh like a
third-rate barmaid's.  I believe subalterns describe
them as 'sports.'  They aren't men, though they try
to ape men; they aren't women—they aren't—oh
God! how I hate the type!"
</p>
<p>
Lady Manners rose.  There was in her aristocratic,
rather narrow face, a suspicion that her relative had
been drinking.  Once on a previous visit the idealist
had been driven by boredom to seek entertainment in
the village tavern, and, while adding considerably
to his popularity amongst the rustic toss-pots,
returned smelling insufferably of beer.
</p>
<p>
"Don't go, Emily.  Don't shove off for a second.
I only get wound up like this once in a blue moon,
and I'd better get it off my chest now once and for
all.  Don't imagine I think these Miss Smedleys
represent women war-workers.  I know they're a
minority, but they represent a type.  I know
something about the other sort—the ones who've helped us
to bash the Hun, and they make me feel like a piffling
slacker sometimes.  How would you like to stand on
your feet for twelve hours a day doing acetylene gas
welding, or ride eighty miles carrying spare parts on
a stink-bike through a snow blizzard—not once, but as
a daily routine?  I was shipmates with a bloke whose
sister did that for two consecutive years.  How would
you like swabbing out a gangrened wound in a part
of a man's anatomy polite civilisation makes him hide
under clothes—-?  Don't raise your eyebrows,
Emily!  The point I'm driving at is that thousands of
women do these things, and somehow manage to
remain women——"  He mused reminiscently upon a
then recent article in Blackwood's Magazine—"Even
when they pull off their petticoats and put on breeches
to plough an acre a day."
</p>
<p>
"I am sorry," said Lady Manners, on the threshold
of the hall.  "But I quite fail to see the application of
all this—this rant."
</p>
<p>
"It applies to Josephine Smedley and her kidney,"
replied the seeker-after-ideal-womanhood.  "It is my
'statement in mitigation.'  You, my dear Emily,
having donned the black cap and condemned me to a
tea-party with the lady in question, cannot do less
than listen to my views."  Graeme beamed at her irate
ladyship, his ill-humour blown away on the winds of
vehemence.  "And now here is Malcolm bowed down
with the affairs of the nation."
</p>
<p>
Sir Malcolm Manners, who wore a preoccupied air
and carried a sheaf of letters in his hand, entered as
Graeme spoke.  He was a meagre individual with
absent blue eyes and a drooping moustache tinted by
nicotine.  His thin grey hair was parted unsymmetrically
down the centre, and one wisp, perpetually overlooked
or rebellious against restraint, stuck up from
the crown like a cock's tail in miniature.
</p>
<p>
He stopped when he saw his wife and referred
fussily to the letters he carried, as if to
refresh his mind from notes preparatory to making
a speech.
</p>
<p>
"We must go up to town for a few days, Emily.
These fellows are going to muddle everything without
someone on the spot."
</p>
<p>
By "someone" he meant himself.  The baronet
was Chairman of a Committee charged with the task
of repatriating certain classes of refugees.  The
refugees having no wish to be repatriated and the
Committee boasting not a single business man in its
composition, matters were not progressing as rapidly—so
said the type-written report in the Chairman's
hands—as could be hoped.
</p>
<p>
"Ha!" said the lady, scenting muddle like a war-horse
sniffing battle.  There are women who rush to
straighten out other people's affairs with a gusto only
equalled by the discovery of dust in their own rooms.
They make admirable housewives.  Then, somehow,
into the pleasurable anticipation of good work ahead,
of fussy Committee meetings and the rounding up of
expostulating unintelligibles, there floated the
recollection of Graeme into their minds.
</p>
<p>
"You don't mind if we run away for a few days,
Graeme—you can amuse yourself all right till we come
back I dare say?  It's a nuisance—but you know what
these confounded fellows are if you leave them to
themselves."
</p>
<p>
Sir Malcolm brandished the papers in vague
admonition of his absent fellow-repatriators.
</p>
<p>
"Quite," said Graeme, wondering what they were
all talking about.  Then, perhaps realising that
something more was required of him, added: "I'll be quite
all right alone.  Have no end of a time.  Don't either
of you hurry back on my account."
</p>
<p>
"There are no engagements to bring us back till
the end of the week, are there Emily?" queried Sir
Malcolm.
</p>
<p>
"Not that I can remember."  Lady Manners walked
to a bureau and consulted a little tablet of memoranda.
"Oh, I had forgotten, I wrote this morning to the
governess in charge of those children staying at Glebe
Farm, asking her to bring them to tea the day after
to-morrow.  They are the children of Admiral
Halliday; you remember, we met him and his wife at
Portsmouth the year before the war—when we stayed
with the Farehams."
</p>
<p>
"Pretty woman, was she?" inquired Sir Malcolm.
"Or was it the one who liked boiled eggs with her
tea?"
</p>
<p>
"It's immaterial," said his wife.  "The children
have had chicken-pox and are convalescing.  I
understand they are free from infection."
</p>
<p>
"They've stopped peeling," said the voice of
Graeme.
</p>
<p>
"Eh?" said Sir Malcolm, wheeling with a
surprised expression.  He had a way of forgetting his
brother-in-law's presence and being startled when he
spoke.  "That needn't bring me back from town,
need it?"
</p>
<p>
"Not at all," said Graeme cheerfully.  "They'd
probably start again if they thought they'd dragged
you back."
</p>
<p>
The baronet looked still more confused.  "Start
what?  I don't understand.  What have I got to do
with these children and their complaints?"
</p>
<p>
"Nothing," said his wife, in the tone the keeper of
an imbecile might adopt.  "They are only coming
here to tea when we are away.  Graeme, of course,
would consider it beneath his dignity to entertain
children"—she smiled rather frostily—"so
Mrs. Mackworth must give them their tea and show them
the picture gallery, and—er—Baines shall take them
round the gardens.  That will leave Graeme free from
all responsibilities in our absence."
</p>
<p>
"Thank you," said the officer referred to.
"Always grateful for small mercies."  He looked at
his watch, and lounged off towards the stairway.  "I'm
going to shift for dinner."  At the first landing he
paused and looked back.  "By the way, Emily," he
said, "have they accepted?"
</p>
<p>
"Who?" asked Lady Manners, her head once
more full of the affairs of the about-to-be-repatriated.
</p>
<p>
"Those children."
</p>
<p>
"No.  If a letter comes you had better open it,
and let Mrs. Mackworth know if they are coming."
</p>
<p>
"I will," said Graeme.  "But, oh, who wouldn't
sell his little farm and go to sea!"
</p>
<p><br/>
<br/>
</p>
<p class="t3">
3
</p>
<p>
Cornelius James claimed the right to be the bearer
of the acceptance to Lady Manners' invitation by
virtue of having been the first to discover Graeme.
</p>
<p>
Georgina, doomed to an hour's violin practice, was
immured in the stuffy farm parlour amid waxen fruit,
daguerreotype portraits and family Bibles.  Jane, after
a spirited bid for the post of messenger, sought
consolation in the region of the sheep-dip, speedily
becoming as excited and almost as wet as the struggling
animals themselves.  Miss Mayne, having borrowed
an iron from the farmer's wife, retired to the sitting-room,
where, with pretty brows knit in the preoccupation
of <i>blanchissage</i>, she was no longer a governess,
but a slim priestess before a vestal altar, aloof,
mysterious.
</p>
<p>
Cornelius James, turning his back on these
feminine activities, pursued a stony lane that climbed
through sloping fields and presently debouched upon
the main road.  The lodge gates of his destination
stood a few hundred yards higher up, but boylike he
disdained so formal an entrance, and nosed along the
high palisade surrounding the park until a displaced
board gave him access.
</p>
<p>
The trees grew thick and untended as in a wilderness,
with moss clinging to their bark and the verdure
wellnigh shutting out the sky.  Underfoot the dead
leaves of countless autumns' garnering rustled crisply
and, as the boy advanced, twigs snapped at every
step; something startled by his footfall bounded away
through the fern unseen.  To the ears of boyhood,
Pan's pipe has not grown dim, and it was with a
heart that thumped responsive that Cornelius James
crept forward.
</p>
<p>
His imagination, acutely vivid and rather childish
for his years, insisted that this was a desperate
business, demanding caution and woodcraft of no mean
order.  Indians, painted and feathered, slipped like
shadows from bole to hollow; a tiny pool amid the
bracken was the nightly drinking-place of beasts a
hunter of his experience could recognise from their
spoor....  A squirrel, low down on an overhanging
branch, suddenly sent his heart into his mouth as it
broke into a scolding chatter at his approach.
</p>
<p>
The trees grew fewer and gave glimpses of great
stretches of lawn, vivid green in the brilliant
sunlight.  Beyond, entrenched behind flower-beds and a
stone balustraded terrace, stood the great house.  Had
Cornelius James but known it, romance clustered
thicker round those hoary buildings than any he could
imagine in his woodland transports.
</p>
<p>
Monks had chanted matins and vespers in the
vaulted chapel whose roof caught his eye amid the
greenery.  Brave gentlemen had died at the end of
the alley-way bordered by yew hedges on the right—fought
and died for the light love of a lady.  Dawn
had paled candles behind the deep-set oriel windows
and seen a fortune, aye, ten fortunes, change hands
across a little baize-covered table.  The births of
great men and famous women and their deaths
had the old house known for twenty generations,
and once (so the chroniclers record) murder
most foul.
</p>
<p>
But the boy was less concerned with the house
than the gleam of a lake beyond the lawns.  Water
always called him, were it sea or river or puddle by
the roadside.
</p>
<p>
He emerged from the park, a hot, dishevelled,
breathless little figure, and set off at a trot to where
the ornamental lake was situated.  A stream meandered
down to the head of the lake, and following it
he came presently to the stone coping (it had been a
fish pond in monastic days) and espied a tall figure,
lazily whipping the surface of the lake with a trout
rod.  It was Graeme Jakes, and so intent was he
upon his occupation that not until Cornelius James
panted to his side did he turn his head.
</p>
<p>
"Hullo, sprite!" he said.  "Where have you
sprung from?"
</p>
<p>
"I've got a letter," gasped Cornelius James,
"about our coming to tea with you."
</p>
<p>
"Oh," said the prospective host, and then in a
tone of anxiety that would have astonished his
step-sister: "You are coming, aren't you?"
</p>
<p>
"Rather," said the boy.  "We're all coming."  He
held out the letter.  "This is for Lady Manners.
Shall I go in and give it to her?"
</p>
<p>
"That's all right," said Graeme, possessing himself
of the missive.  "I'll take it."
</p>
<p>
He wound in his line and stood staring across the
lawns in the direction of the old house.
</p>
<p>
"We are looking forward to coming," said
Cornelius James.  "Frightfully.  Jane hopes we can
play hide and seek."
</p>
<p>
"Of course you can," said Graeme.  "You can
do any blessed thing you like."
</p>
<p>
"And you'll play, too?"
</p>
<p>
"I?"  Graeme's tone was one of apprehension,
but mingled with it was a note of pleased anticipation
the child's ear was quick to catch.  "Are you sure
you want me?  I'm not much good at games; it's
rather a long time since I played hide and seek, you
know."
</p>
<p>
"Of course you'll have to join in," replied Cornelius
James.  They were walking side by side in the
direction of the house.  "That's all we're coming
for."  He looked up into Graeme's face with a boy's
frank affection in his gaze.
</p>
<p>
There are men proof against the blandishments of
women, charm they never so wisely, but none entirely
unsusceptible to a child's naïve advances.
</p>
<p>
Graeme flicked the supple rod to and fro over his
shoulder.
</p>
<p>
"Right-ho!" he said gruffly, and then after a
half-awkward pause added: "Would you like a
peach?"
</p>
<p>
The boy signified assent to the proposal, and they
skirted the flower-beds, leaving the house on their
left and entered the walled garden.
</p>
<p>
Cornelius James rapidly disposed of two peaches
and a pear while Graeme stood watching him with a
smile lurking about the corners of his mouth.
</p>
<p>
"Better take some back for the other sprites," he
said, and gathered four peaches.  "Here you are—two
each.  Shove 'em in your pockets."
</p>
<p>
Cornelius James gravely accepted the gift, and
prepared to depart.
</p>
<p>
"Thanks awfully," he said, and hesitated.  "I
say, would you mind if I took one back for Miss
Mayne?  She loves peaches."
</p>
<p>
"I'd forgotten Miss Mayne," he said.  "Of course
she can have some.  Here!  Where's your cap?"  He
selected and picked the fruit with a preoccupied
air, then suddenly; "Does—does Miss Mayne play
hide and seek?"
</p>
<p>
Cornelius James nodded.  "She plays everything,"
he said with enthusiasm.  "You wait!"
</p>
<p>
They had regained the terrace and stood looking
out across the smiling countryside.
</p>
<p>
"You haven't seen Miss Mayne yet, have you?"
</p>
<p>
"No," said Graeme.  He stood motionless for a
minute after his visitor had departed, watching the
small figure dwindling in the distance.  Then drawing
the letter from his pocket he opened and read it.
It was a formal acceptance of half a dozen lines
written in a clear, round, rather girlish hand and
signed "Claire Mayne."  But the reader scrutinised
it as if it had been a photograph, and re-read it twice
ere he replaced it in his pocket and walked slowly
back to the house.
</p>
<p>
"I wonder what she looks like," he said, musing,
and then remembered rather uneasily that he had
omitted to mention to his visitor the absence of the
mistress of the household.  In the hall he encountered
the housekeeper.
</p>
<p>
"Oh, Mrs. Mackworth, those children are coming
to tea to-morrow.  I shall be in, and I
will—er—entertain them."
</p>
<p>
Mrs. Mackworth, who had had in contemplation a
tea-party to two cronies in her own room, looked
relieved at the intelligence.
</p>
<p>
"Then you won't require my presence, Mr. Graeme?"
</p>
<p>
"No, thank you," replied Graeme, with the desperate
calm of a man who had deliberately burned his
boats.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
4
</p>
<p>
The following morning found the children in
a glow of pleasurable anticipation which their
landlady, on learning of the impending visit,
cheerfully fanned to fever pitch.  She had been a
housemaid "up at the house" in her youth, and held
the children spellbound with her description of
its glories.
</p>
<p>
"There's armour there enough for a regiment of
soldiers," she said with fine disregard of modern
military equipment, "and pictures by the mile.
Chimney-vases hundreds of years old, worth their weight in
gold, standing about in corners like dirt.  Mind,
too," she added, with a ring of sombre reminiscence
in her tones, "they break if you so much as look at
'em.  Don't forget to see the tapestry that was wove
by a queen and her ladies, and if Mr. Graeme's
there, get him to show you the secret passage—there's
one behind a sliding panel in Sir Malcolm's
library."
</p>
<p>
"Oh!" gasped Jane and Cornelius James in chorus.
</p>
<p>
"Graeme will be there," cried the latter with
dancing eyes.
</p>
<p>
"And a nice young gentleman he is," said the
woman.  "Comes here to get my husband to go
ferreting and drops in afterwards for a cup of tea.
Quiet, you know, and unassuming; happier, they
say, with us farmer folk than with lords and ladies
of the County.  That's the gossip in these parts, but
I was never one myself for——"
</p>
<p>
"Did you say we should meet him?" inquired
Georgina of her brother, with lofty indifference a
shade over accentuated.
</p>
<p>
"Yes," was the reply, "and you needn't put on
airs because you are going to have tea with a
grown-up man."
</p>
<p>
"And a silly little boy," retorted Georgina,
nettled.  She sighted Miss Mayne.
</p>
<p>
"Corney's frightfully jealous that we're going
to steal his beloved Mr. Jakes from him," she
scoffed.
</p>
<p>
Miss Mayne laughed merrily.  "Cheer up,
Corney," she said.  "We don't want your old
Mr. Jakes, whoever he may be."  She rumpled his hair
affectionately.
</p>
<p>
The child slipped his arm through that of the
woman.
</p>
<p>
"No," he replied, and looked up at her fair face
quizzing down at him; a little smile lit his eyes in
innocent roguery.  "No, but he may want <i>you</i>!"
</p>
<p>
"Oh!" exclaimed Miss Mayne.  "Why, I do
believe Georgie was right!"
</p>
<p>
"How right?"
</p>
<p>
"I believe you are a silly little boy, after all."
</p>
<p><br/>
</p>
<p>
Beneath another roof in the country Graeme Jakes
formed the topic of conversation that summer
morning.  The Misses Smedley were alone in the
music-room of The Garth, where Alicia was practising a
"Jazz" waltz on the piano.  Josephine, swaying her
body sinuously to the rhythm, smoked a cigarette
while she stared out of the window.
</p>
<p>
"He's not what you'd call good looking," she
said, "exactly."
</p>
<p>
"No," replied Alicia, turning her music and
nodding jerkily as the tune progressed.
</p>
<p>
"All the same," said Josephine, "there's something
rather——" she writhed expressively.
</p>
<p>
The fair Alicia played in silence for some moments.
"Don't work up a 'pash' over him till you know
more about him.  For all you know, he's married
already—or wrapped up in another girl.  Sailors are
devils."
</p>
<p>
Josephine took three "Jazz" steps across the
room and threw the stump of her cigarette into the
fireplace.  "I like devils," said the supple virgin,
"'specially ugly ones."
</p>
<p>
Her sister stopped playing, wheeled round on the
music-stool, and taking a cigarette out of a box on
the piano, bounced it end-on with merciless violence
against her thumbnail before putting it in her mouth.
</p>
<p>
"I believe you are so dev'lish intrigued with this
man because he snubbed you the other day," she
drawled.
</p>
<p>
Josephine laughed.  "There are some men one
would rather like to be beaten by——  Al, can you
think of an excuse to go over there this afternoon?
What about those theatricals at Aldbury—can't we
ask him to act in them?  He won't, of course—that
sort's too self-conscious—but it would be a decent
excuse."
</p>
<p>
"Obvious," said the more experienced Alicia.
</p>
<p>
"Rot—be a sport."
</p>
<p>
"But he leaves me cold," objected the "sport."
</p>
<p>
"So much the better.  Didn't I help you when
young Maunder was staying at Norton Hall?  You
owe me one over that."
</p>
<p>
"Oh, all right, then," assented Alicia.  "I shall
have to gas to Lady Manners all the afternoon.  'Snice,
I don't think."
</p>
<p>
"Lady Manners is away.  Gone to town with old
Sir Stick-in-the-mud.  But, of course, we shan't
know that—get all in a flutter——"
</p>
<p>
Alicia opened her heavy-lidded eyes wide.  "My
dear!" she cried, and then, spinning round to the
key-board, vamped the opening bars of Mendelssohn's
Wedding March.
</p>
<p>
"Shur-r-r up!" shrieked Josephine, with a burst
of abrupt laughter somehow suggestive of the cry of
the green woodpecker.
</p>
<p>
All unconscious of the tremors he had awakened
in the maidenly bosom of Josephine Smedley,
Graeme Jakes sallied forth to meet his guests.  He
had mapped out a programme for their amusement
with considerable care, harking back in memory to
the far-off days when as a little boy he was bidden to
spend adventurous afternoons at adjoining country
houses, where there were always swarms of children,
and the gardeners locked the doors of the
wall-gardens as a precaution——
</p>
<p>
Well, there would be no doors locked that afternoon.
He had seen to that, and the tea, with its piles
of cakes and pyramids of fruit, bowls of cream and
dishes of Mrs. Mackworth's famous preserves,
materialised the vision of a meal he had always
dreamed as a child, and somehow never achieved
in waking hours.
</p>
<p>
He met his guests half-way up the avenue through
the park, a demure-looking little group from which
first Cornelius James and then Jane detached
themselves and sped to greet him.
</p>
<p>
"Look," said Jane, extending decorously gloved
fingers, "tell Miss Mayne you hate people with
gloves.  She made us wear them—Georgie and me."
</p>
<p>
"Did she?" said the host, and advanced to
welcome the autocrat who had decreed gloves.  Of
course, Emily would expect children to wear
gloves——
</p>
<p>
He was face to face with Miss Mayne, with
Georgina at her side.  The governess had overheard
Jane's protest, and was laughing as they shook hands.
Graeme approved of her laugh; it produced tiny
wrinkles at the side of her nose, giving her face an
ingenuous and infectious merriment.  Despite the
pre-occupation of the apology he was mentally
framing, Graeme noticed that her eyes were grey, and
that there were freckles powdered like gold-dust about
the attractive nose.
</p>
<p>
"I ought to have let you know before," he said.
"I hope you don't mind, but the fact is, my step-sister
is away.  She and her husband have had to go
up to town."
</p>
<p>
The smile faded from Miss Mayne's face.  "I'm
sorry.  We didn't know."
</p>
<p>
Her regard, meeting the man's, somehow reminded
him of the searching look Cornelius James
had given him at their first encounter.
</p>
<p>
"Emily entrusted me with the job of explaining
her absence and apologising.  I should have done
both sooner, but, somehow, it never entered my head.
I have been looking forward so much to having a
party——"  He grinned boyishly and flushed.
</p>
<p>
Miss Mayne Was sophisticated enough to interpret
aright all that quick flush meant.  Her smile returned
like a reassured rabbit sallying forth again from its
burrow.
</p>
<p>
"It's very brave of you," she said, "and we are
ever so grateful, because we've been looking forward
to this afternoon, too, haven't we, Georgina?"
</p>
<p>
Georgina awkwardly confirmed this; she was at
the shy age of girlhood—the age at which youth finds
itself a trifle superfluous in Nature's inexorable
scheme.
</p>
<p>
"Very well, then," said their host, "we will proceed
according to plan, as the Hun said when he
retreated," and led the way towards the house.
</p>
<p>
For the first time in his life he played the host,
and the rôle became him.  True, the house was not
his, but he knew and loved it, in his shy, unobtrusive
fashion, and showed a knowledge of its contents that
more than once caused Miss Mayne to glance at him
with a half surprised, veiled appreciation.  She
herself spoke little, but, when she did, displayed a love
of the beautiful and no small knowledge of many of
the arts that beautified the interior of the mansion.
The little party had reached the portrait gallery, and
at Georgina's request Mouldy Jakes furnished them
with thumb-nail sketches of the life histories of the
originals.  He talked in a dryly humorous fashion
that held the children alternately entranced and
convulsed with laughter, warming to his self-imposed
task as Miss Mayne caught the infectious mirth and
echoed the children's gurgles with her own clear
sweet laugh.
</p>
<p>
"And who is that?" inquired Georgina, pointing
to a bloodless-looking dame in blue satin holding a
toy spaniel in her preposterously tapering hands.
</p>
<p>
"Ah!" said their host, "now we're getting
to the really interesting ones.  I was saving her
for the last.  There's a story about her you won't
believe."
</p>
<p>
"Tell," commanded Jane, possessing herself of
his undamaged hand.
</p>
<p>
"Well, this particular lady died—or at least they
thought she was dead, and they planted—that's to
say, buried her, in the vault attached to the chapel—I'll
show you the place later on.  She had a wedding-ring
which was supposed to carry special luck to its
wearer—it was rolled out of a piece of gold looted
from a joss-house by some adventurous Manners.
Anyhow, she was buried with this ring on, and in
the night, one of the gardeners thought that, being
alive and having use for good luck, he might as well
have the ring as leave it where it was."
</p>
<p>
"Oh," said Miss Mayne, "I know the story—never
mind, go on!"  She turned and stared curiously at
the impassive features of the lady.
</p>
<p>
"Well, the gardener got hold of the ring; he'd
been apprenticed to a burglar as a lad before he
took up gardening, and he had strong nerves as
well.  The trouble was that he couldn't separate
the ring from the lady, and he didn't want her.
He pulled hard, but he couldn't get it off.  Not for
nuts."
</p>
<p>
"I know what <i>I</i> should have done," said Cornelius
James.  "I should have cut off her finger."
</p>
<p>
"Corney!" protested his shocked sisters.
</p>
<p>
"Well, that was more or less his idea.  The
trouble was he hadn't got a knife—he wasn't a sailor;
but he had been the next best thing for the
purpose—a dog-fancier."
</p>
<p>
"I thought you said he had been a burglar?"
interposed Jane severely.  Consistency in
details she invariably insisted upon when told a
story.
</p>
<p>
"Oh," gasped Miss Mayne, as the significance of
the gardener's former pursuit suddenly became plain,
"you surely don't mean——"
</p>
<p>
"He was in a hurry.  P'raps the job was getting
on his nerves after all.  He started in, and when he
was half-way through the lady sat up.  She wasn't
dead—only in a trance."
</p>
<p>
"What did the gardener do?" asked Cornelius
James feverishly.
</p>
<p>
"At the time he ran away," replied Mouldy in
sepulchral tones, "but later on he repented and joined
the Church."
</p>
<p>
"And the lady lived happily ever afterwards?"
insisted Jane the punctilious.
</p>
<p>
"Certainly," said Mouldy.  "And now, before we
have tea, I'll show you all the ring."  He ran up the
stairway at the end of the gallery and returned a few
minutes later with a little casket.
</p>
<p>
"It is supposed to bring luck to any woman
who slips it on her wedding finger," said the host,
opening the lid and taking out a heavy plain
ring.
</p>
<p>
"Let me put it on," said Georgina.  She extended
a slim sunburnt paw, and Mouldy gravely slipped it
on the third finger of her left hand.
</p>
<p>
"What a weight," she said, and turned her hand
admiringly, contemplating it after the manner of
women, with her head on one side.
</p>
<p>
"Do you feel all funny?" inquired Jane, with
obvious anxiety.  "The luck——"
</p>
<p>
"No, silly," replied her sister.  "Here, you put it
on."  She drew it off and slipped it on Jane's small
finger.  "Now Miss Mayne."
</p>
<p>
Miss Mayne shook her head laughingly.  "No,"
she said, "my luck doesn't want any improving.  I'm
quite content with everything as it is."
</p>
<p>
Her host glanced at her quizzically.  She certainly
did not look as if she had many grounds for complaint,
as she stood with her hands behind her back
and mirth in her pretty eyes, a gracefully poised,
perfectly healthy, happy specimen of young womanhood.
</p>
<p>
"Oh, Miss Mayne, but you must!" cried her
charges in unison.
</p>
<p>
"You can never have too much of a good thing,
you know," endorsed the host.  Without quite knowing
why, he was aware that his heart was beating a
shade fast.  He wanted her to put the ring on.  He
had an absurd inexplicable desire to put it on her
finger himself.
</p>
<p>
"Just put it on the tip," pleaded Jane.  "Please."
</p>
<p>
Miss Mayne was now blushing unaffectedly, and
furious with herself.
</p>
<p>
"Why not?" asked Graeme with masculine obtuseness.
</p>
<p>
"You needn't put it right on," said Georgina
soothingly.  Abruptly Miss Mayne yielded.  The
affair threatened to develop into a scene; she felt
self-conscious and embarrassed.
</p>
<p>
"Very well," she consented, and held out her hand
to Jane.  "Put it on the tip, it's too small for me to
wear."
</p>
<p>
Jane complied, but Cornelius James intervened
and pounced on her extended finger.  "No, no," he
cried, "properly!  You must have all the luck!" and
thrust the gold circle over her knuckle.
</p>
<p>
Miss Mayne tugged at it unavailingly.  The
blush had gone and a look of annoyance creased her
brows.  "It won't come off," she murmured.
</p>
<p>
"Never mind," said Graeme; "don't worry.
We'll have tea, and then Mrs. Mackworth shall
bring you some soap and warm water.  Tea's ready
now."
</p>
<p>
"I'd rather——" began the girl, and stopped.
She had made enough fuss over the wretched thing,
she decided.  "Very well," she said reluctantly, and
they descended to the dining-room, and the Gargantuan
repast Graeme had prepared.
</p>
<p>
As the meal progressed, the friendly relations
Graeme had established with the children increased
to something approaching intimacy.  Miss Mayne's
annoyance disappeared and her whimsy of a smile
returned.  The incident of the ring was forgotten,
and no one mentioned it.  Only she remained
somehow conscious of it as she sat with her
hand unobtrusively concealed from view upon
her lap.
</p>
<p>
Tea was nearing its conclusion when the butler
entered and approached Graeme's chair.
</p>
<p>
"The two Miss Smedleys, sir, have called.  I
said her Ladyship was away, but they said, if they
might, they'd like to see you for a minute."
</p>
<p>
"See <i>me</i>!" groaned the victim.  "Oh, who
wouldn't sell his little farm and go to sea?  Why do
they want to see me?"
</p>
<p>
"Couldn't say, sir," said the butler, with faint
disapproval in his tone.
</p>
<p>
Graeme gazed at him with undisguised panic in
his face.
</p>
<p>
"Look here, Hobbes," he said, "I'm not going
to face those man-eaters alone.  You can show
'em in here.  I suppose they'll have to have
tea."
</p>
<p>
Then to the children, who sat wide-eyed and silent
during this confab, he appealed.  "You'll all help
me, won't you?"
</p>
<p>
"Rather!" exclaimed Cornelius James, all his
martial instincts aroused by the reference to
man-eaters, but quite at a loss as to what was expected
of him.
</p>
<p>
"Course we'll help," echoed Georgina, with something
nearer comprehension.
</p>
<p>
"Well, then, you must just pretend I'm your
father."
</p>
<p>
"What fun!" cried Jane, and they rose as the
door opened and the Misses Smedley stood, somewhat
taken aback, on the threshold.
</p>
<p>
"How d'you do," said Graeme advancing.  "I
hope you don't mind a schoolroom tea round the
dining-table, but the fact is, I—when the children are
here—we always have tea together."
</p>
<p>
The Misses Smedley bowed confusedly to Miss
Mayne.
</p>
<p>
"We won't stop, ta fearfully all the same—we
only wanted to ask you to act in some theatricals,"
said Josephine; "they're next week, and we're in a
tearing hurry.  Think it over and let us know as soon
as you can."
</p>
<p>
"<i>I</i>," said Graeme.  "Do you mean you want <i>me</i>
to act?"  He turned to the party round the table.
"Children, can you imagine your father acting in
amateur theatricals?"
</p>
<p>
The response was an outburst of unbridled merriment,
in course of which Cornelius James, seated next
to Miss Mayne, upset his teacup.
</p>
<p>
The Misses Smedley took advantage of the
ensuing confusion to beat a retreat.
</p>
<p>
"Well," said Alicia, "we just popped in on the
off-chance you would, don't you know, being next-door
neighbours, and all that kind of thing.  Now we must
fly off and beat up someone else."  Her insolent eyes
roved round the table.  She appeared to be
preoccupied with some mental arithmetical calculation.
</p>
<p>
"Won't you have some tea first?" said Miss
Mayne.  The instant she had spoken she regretted
it, but the intimacy of the afternoon, the feeling of
knowing almost as much about the house and its
contents as the owners, perhaps some faint promptings
of loyalty to her sex, produced a spontaneous
offer of hospitality that she knew was not hers to
make.
</p>
<p>
"No, thanks really," said Josephine, already in
retreat.  "We haven't time now.  Good-bye, and do
try to persuade your husband to help us with these
wretched theatricals."
</p>
<p>
Graeme and Miss Mayne stared blankly at each
other.  Through the open window came the sound of
a car being cranked furiously.
</p>
<p>
The children's faces were eyeing their elders as
if uncertain how to take this unexpected turn of
events.
</p>
<p>
"They don't really eat men, do they?" said the
awed voice of Cornelius James.
</p>
<p>
"You don't honestly think——" began Miss
Mayne, her colour once more supplanting her smile.
"Oh, couldn't you tell them—run out and say I—we——"
</p>
<p>
Graeme hastened after the visitors with belated
promptings of conscience and the laws of hospitality,
but before he reached the hall the splutter of gravel
and the hum of the engine told the listeners in the
dining-room he was too late.
</p>
<p>
"He's waving good-bye," said Alicia, as the car
swerved and rocked down the avenue, looking back
and brandishing her gloves.
</p>
<p>
"Let him!" snapped Josephine, opening the
throttle.  "Some men are the limit.  Fancy all those
children.  Disgusting, I call it.  Why, the eldest
was fourteen, if she was a day."
</p>
<p>
"<i>She</i> looked idiotically young," said Alicia.
</p>
<p>
"Probably their step-mother.  Didn't she look
daggers when we walked in!  I suppose she is his
wife?"
</p>
<p>
"'Course she is; didn't you see her wedding
ring?  I spotted it when that kid upset his cup and
she started mopping up the mess.  'Course she's
his wife."
</p>
<p>
"H'm," was the comment of the sporting Alicia.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
5
</p>
<p>
Graeme Jakes accompanied his guests as far as the
gateway to Glebe Farm when finally they departed.
The sun was dipping behind the hills and rabbits were
showing themselves along the lane; it was a golden
evening of incredible peacefulness, but in Graeme's
mind a shadow of remorse lingered.
</p>
<p>
"Look here, Miss Mayne," he began awkwardly
when a temporary absence of the children, who had
run to greet the farm terrier, made intimate speech
possible.  "I'm awfully sorry for the stupid mistake
that Smedley girl made.  I feel I am really to blame,
although nothing was further from my mind——"
</p>
<p>
Miss Mayne was silent and Graeme shot a swift
glance at her profile which, beyond enabling him to
note that her eyelashes were long and curved up a
little at the tips, afforded him no comfort.  They
walked a few paces through clouds of jigging
gnats.
</p>
<p>
"Shall we not talk about it any more?" said Miss
Mayne at length.
</p>
<p>
"I don't want to talk about it.  I only wanted to
reassure you, in case you might feel any annoyance.
You see, they'll have found out the truth by now.
They certainly won't waste time making
inquiries——"  He smiled grimly.  "And if anything more
comes of it, the worst will be a visit of apology to you
from the pair of 'em."
</p>
<p>
He crinkled his eyes in the sunset light and
scanned the figures of the children ahead of
them.
</p>
<p>
"Why!" he murmured.  "Of course it's absurd!
It's comic!  Fancy me——" and stopped on delicate
ground.
</p>
<p>
Miss Mayne smiled too.  "I hope I shall be spared
apologies.  As long as they realise at once——  As
you say——"  She hesitated and drove the point
home.  "The idea is—comic!  And," she added
graciously, "I'm not in the least angry with
you."
</p>
<p>
So ended Graeme's party.  He retraced his steps,
puffing furiously at his pipe, jolted out of the
accustomed orbit of his thoughts as completely as a maiden
after her first dance.
</p>
<p>
On the whole he had enjoyed the afternoon
immensely and found himself wondering why he had
never done anything of the sort before.  They were
such jolly kids; the brown-faced, impulsive Cornelius
James, aglow with imagination and as affectionate as
a puppy; Jane, a feminine edition of him, with thick
hair, "bobbed" above the nape of her white neck (he
had discovered for the first time the witchery that lies
in the back of a child's neck); and Georgina, shy,
long slip of a thing with eyes like a fawn and hints of
a not-distant womanhood in her quick changes of
colour and the pretty immature curves of her young
body.
</p>
<p>
Of Miss Mayne he thought with a queer mixture of
compunction and pleasure.  She so obviously would
have enjoyed the afternoon had it not been for the
lamentable business of the ring, and the ridiculous
remark addressed to her by Josephine Smedley.  Her
husband indeed...!  Somehow that possible
interpretation never entered his head when he suggested
temporarily adopting the children.  The ring she was
still wearing during tea must have been responsible
for it.  He wished they had got it off with soap and
water when she wanted to, instead of leaving it till
afterwards.  "Comic!"  The intonation in Miss
Mayne's voice came back to him as she echoed the
word.  After all, why comic——?
</p>
<p>
He wondered, sailor-like, what manner of man her
brother had been, that dead Guardsman who slept "in
Flanders' fields."  He realised with an unfamiliar
thrill the fearless, frank way she had looked him in the
eyes, the poise of her head, the gay quality of her
laugh, and somehow wished he had had that man for
a pal; he, who since boyhood had never really opened
his heart to another human being.
</p>
<p>
He found a letter from his step-sister awaiting him
on his return.  It was a hurried epistle communicating
the fact that Sir Malcolm was in bed with influenza,
which at that time was raging in London.  It postponed
their return indefinitely and bade Graeme make
himself as comfortable as circumstances permitted in
their absence until the end of his leave.
</p>
<p>
Perhaps nothing more was necessary than this
absence of Lady Manners from the scene to mature
Graeme's friendship with his new acquaintances.
</p>
<p>
From the formal invitation to a return party at
Glebe Farm penned by Georgina and signed by all
three children, they passed by rapid stages to an easy
comradeship.  In a week the boy and both girls were
as free of the demesne as Graeme was of the noisy
teas in the farm parlour.  Further, the latter
unearthed a governess cart out of the stables, and
harnessing a fat pony between the shafts, led them off
on long rambling expeditions amongst the thickly-wooded
hills, and lanes drowsy with the scent of
honeysuckle.
</p>
<p>
It is not for me to attempt any convincing
record of the imperceptible stages by which, as
the days passed, Graeme fell in love with Claire
Mayne.
</p>
<p>
She obtruded upon his thoughts as sunlight enters
a room past curtains waving in the breeze, while with
the dour perversity of his queer nature he tried to
shut her out.
</p>
<p>
There were women about whom no one could
cherish any illusions; with these Graeme Jakes was
half contemptuously, half pityingly at ease.  But in
Claire Mayne he saw someone who approached so
exquisitely to his ideal of womanhood that he dreaded
disillusionment.  Thus and thus must his goddess be
fashioned, and the first word or act of hers that
betrayed feet of clay would have filled him with
bitterness and disappointment.
</p>
<p>
However, as time went on, one after another
he drew forth timidly from the secret hiding-place
of his soul some fresh idealism; draping them
about his conception of her, until the real and the
imaginary woman blended into that dear, everlastingly
inaccessible unreality which is all mankind's
first love.
</p>
<p>
Transports of this nature are usually apparent
enough in the demeanour; but Graeme Jakes's
oriental imperturbability of countenance gave not the
slightest betrayal of the turmoil in his thoughts.
</p>
<p>
Claire Mayne herself remained serenely unconscious
of anything in the air more vibrant than a
grave friendliness and a shy, half-reluctant
admiration.  She would not have been the normal, healthy
young woman she was had she not thought about him
a good deal.  When the children were in bed and the
stars made visible the dark outline of the hills
opposite, she sat by her open window, with the tiny room
behind her in darkness; there, chin in hand, she tried
to assign him to some known category amongst her
limited male acquaintances, and found the task
difficult.
</p>
<p>
Since girlhood her pet character in fiction had been
Alan Breck; not for his swashbuckling gallantry, nor
the efficient way with him in sword play, but because,
as she herself put it, "he wanted looking after so
dreadfully."
</p>
<p>
Graeme Jakes, in some subtle way that eluded
analysis, appealed to her in much the same manner.
His clothes lacked buttons at times and his hair was
generally dreadfully untidy.  She would like, she
thought, to brush his hair for him ... in a brisk,
sisterly fashion.
</p>
<p>
The tranquillity of her meditations would have
been sorely disturbed could she have seen the object
of her thoughts.  Half a mile away, from a vantage
point amid the dewy bracken, stood her devout lover,
watching with all a lover's faculty for self-hypnotism
a light burning behind a blind in one of the upper
windows of the farm.  Fondly he watched its orange
glow through the darkness until it was abruptly
extinguished, and returned home in a mood of exalted
melancholy.  Judge though how greater the melancholy
had he realised the blind screened no other
than the conjugal chamber of the farmer and his
wife....
</p>
<p>
The days went by thus to merge into weeks, and
the children's visit was fast drawing to a close.
Graeme, too, had received orders to attend at the
Admiralty for medical survey.  The halcyon days
were numbered.
</p>
<p>
They had planned an expedition to the coast, an
all-day affair that was to include sea-bathing for the
children, for the last day.  The sun shone out of a
cloudless sky, the air was clear and sweet with autumn
scents, and the cavalcade set forth on the appointed
morning in wild spirits.  Mrs. Mackworth had provided
lunch and tea, and the food, together with bathing
things, cameras, and all the impedimenta of a
holiday, were piled into the pony cart.  Miss Mayne
held the reins and Georgina walked at the pony's
head; Jane and her brother ranged along the hedgerows
like a couple of terriers; while Graeme brought
up the rear, outwardly cheerful, but inwardly
experiencing the varied sensations of a man who has
decided to propose ere the going down of the sun to
a damsel whose only concern appeared to be to avoid
being left alone in his company.
</p>
<p>
They reached the sea about noon; Graeme had
chosen a little bay where the sands were safe for
bathing.  The coast stretched away on one hand in a
waste of dunes and marsh, and on the other rose in
indented cliffs from a rock-strewn beach.
</p>
<p>
On the top of the cliffs they unpacked the
baskets, turned the pony loose to graze, and,
when the children had had their longed-for bathe,
lunched al fresco as might the gods have eaten upon
Olympus.
</p>
<p>
It was after lunch that Graeme made his first
anxious bid for the company of Miss Mayne alone.
"Supposing you three go and explore the caves," he
suggested to the children, a clumsy argument which,
for its very ingenuousness, roused no suspicions in
that maiden's heart.
</p>
<p>
"But what about you and Miss Mayne?" inquired Jane.
</p>
<p>
"Well," said Graeme feebly, "p'raps we'll go
and look for seagulls' eggs along the cliffs."
</p>
<p>
"Gulls don't lay eggs in September," said Miss
Mayne.  "Why shouldn't we all go and explore
caves?"
</p>
<p>
Nothing was further from her mind than the imminence
of the proposal shaping itself on Graeme's lips,
but a pretty loyalty to the children's parents forbade
her to let them out of her vision.  "A nice business,"
said her conscience, "if one of them got hurt.  Where
was Miss Mayne?  Philandering somewhere out of
sight with a Naval officer....  Well, not philandering
exactly, but——"
</p>
<p>
"I thought perhaps you might be tired," broke in
the voice of the Naval officer upon her meditations.
</p>
<p>
"Not in the least," she replied.  "Come along,
we'll all go down to the beach."
</p>
<p>
So off they set and awakened the echoes of the
shallow caves with their voices, explored the pools
left by the tide; built with the aid of pieces of
driftwood a sand castle that had cockle shells for windows
and a tiny green crab as keeper of the gateway, and
through all the absorption of this light nonsense
Graeme was conscious of Claire Mayne, whether she
spoke or was silent, in view or out of sight, as a man
is aware of the sunlight and the wind on his cheek.
She seemed inevitable—inevitable and indispensable.
</p>
<p>
The children found him dullish and rather distrait.
</p>
<p>
Curiously enough it was she who at last gave him
his opportunity to speak his heart.  The children
decreed it was time for their next bathe, and while
they undressed in the shelter of the rocks, Graeme set
about unpacking the tea-things and boiling the kettle.
He watched, kneeling, the three slim forms scamper
across the short stretch of sands in the sunlight to
meet the incoming tide, and suddenly Miss Mayne
joined him on the cliff.
</p>
<p>
"I'll help you," she said; "I can watch the children
from here and cut bread and butter at the same time.
They are quite safe."
</p>
<p>
Her manner was unconcerned; she spoke in the
unrestrained note of comradeship, and stood watching
the children capering in the sunlit waves, with the
wind moulding her garments to her long limbs and
drawing loose tendrils of her hair in careless, happy
disorder across the curve of her cheek outlined against
the sky.
</p>
<p>
Graeme knelt observing her, suddenly tongue-tied.
You can invent speeches to a goddess, aye, and deliver
them effectively enough to a silent night of stars,
but this radiant, composed girl was flesh and blood;
he could almost see the warm vitality glowing through
her skin.  She needed no clap-trap speech about love
such as fellows deliver in novels....  He rose to his
feet.  The wind and the sunshine and the sound of
the sea seemed to sing and shout together.  "Man!
Here's your mate at last!" was the burden of the
song.  "Here's the goal of all your heart's desire; the
haven of your soul's adventure!  Look at her, shaped
for you by incalculable forces and laws, beautified
and perfected and handed down through infinite ages,
to stand thus within your arms' reach.  Yours, man,
if you can but win her!  Tell her, fool ... tell her."
</p>
<p>
"I'm glad you came," said the fool, and his voice,
husky and unfamiliar, startled him.
</p>
<p>
A sound, distinct from the noises of wind and
shore, obtruded upon his consciousness as he spoke,
and the girl heard it too, for she wheeled sharply and
stood staring, not at her companion, but back across
the sheep-cropped turf.
</p>
<p>
Two horses were approaching at a canter, near
enough already for their riders' faces to be
discernible.  One was Josephine Smedley; the other, a
vapid-faced young man in extravagant equestrian
attire.  They drew rein and approached the cliff at a
walk, Miss Smedley waving her whip in greeting.
Her companion touched his horse with the spur,
holding it on the curb while it curveted effectively.
</p>
<p>
"Topping day!" cried Josephine.  "Watching
the kids bathe, Mrs. Jakes?"
</p>
<p>
Graeme heard the girl give a little gasp.  She
stood quite motionless for a few seconds and then,
still staring at the rider, he heard her say in a low
voice, as if speaking to herself: "This has gone far
enough; it's got to stop."  Miss Smedley's cavalier
had rather overdone the spur business and was
having considerable difficulty in controlling his horse,
which was plunging and pulling some distance
away.
</p>
<p>
Graeme stepped forward.  "I'll explain," he said.
"Miss Smedley——"
</p>
<p>
"No," interrupted Claire Mayne, "leave this to
me.  You should have explained before this."  She
took a few steps in the direction of the other girl.
"Miss Smedley," she said in a clear voice, "I think
it only right I should tell you I am not married.  I
am not Mr. Jakes's wife."  She paused, apparently
from loss of breath.
</p>
<p>
In the middle distance the young man, obviously
losing control of his mount, was shouting something
over his shoulder.  Miss Smedley glanced in his
direction and then looked Claire Mayne brutally from
head to toe.  "Please don't apologise," she said,
"I—we suspected as much."  It took the short, hard
laugh that followed the words to drive the insult
home.  She flicked her horse sharply on the flank and
rode after her escort.
</p>
<p>
The sound of the horses' hoofs had died away
before Miss Mayne spoke.
</p>
<p>
"Did she mean—was that woman trying to——?"
she began, and stopped.  Mechanically she knelt
down and began setting out the tea-things as if in
a trance.
</p>
<p>
"Why didn't you leave it to me?" expostulated
Graeme, kneeling beside her.  "I'd have explained
properly.  She misunderstood ... or pretended to."
</p>
<p>
The girl raised a face from which all vestige of
colour had fled.  Her eyes were wide and pitiful;
she held a sugar basin in one hand, in the other a
butter knife.
</p>
<p>
"But I did explain," she said.  "How could I
know...?"
</p>
<p>
"You should have left it to me," repeated Graeme.
He put out his hand and took the sugar basin from
her.  She laid the butter-knife with precision
beside the cabbage leaf containing the butter.  Their
actions were mechanical and inconsequent, as if
the kneeling figures were two automata actuated by
wires.
</p>
<p>
"I thought I'd left enough to you," she said.
"You laughed it over the first time, as if it were a
joke.  Perhaps it was a joke.  One would rather look
at it in that light.  But at least you could have made
sure there would have been no second misunderstanding.
No possibility of my being—being
insulted."  The colour flamed back into her cheeks.
"And you did nothing—nothing."  She bit her lower
lip to control its trembling.
</p>
<p>
Graeme forced a wan smile.  "There wasn't time,
then....  But I will do something—and anyhow, it
doesn't matter, really."
</p>
<p>
"Doesn't matter!" she echoed in frozen tones.
"<i>Doesn't matter</i>!  You put me in odiously false
positions, you expose me to an outrageous insult ... and
you—you laugh and say it doesn't matter!  Oh, this
is intolerable!"  Angry tears forced themselves to
her eyelashes.
</p>
<p>
Graeme groped for the hand that fumbled for a
preposterous handkerchief (with what care had that
little scrap of cambric been selected a few short hours
before, and with what unconsciousness of the purpose
it would serve!)  "Claire!  Claire! don't you
understand, I want you to marry me."
</p>
<p>
She whipped to her feet.  "Oh, don't be absurd!"
she cried.  "Do you imagine—is this your idea of
doing something?  Of rep—reparation for dragging
my name—my brother's——"  She was weeping
now.
</p>
<p>
From somewhere on the sands below came the
voices of the children returning from their bathe.
With a wrung heart Graeme realised his chance had
gone; the children could see them.  Miss Mayne
turned her face from the sea.  "I'm going for a
walk for a few minutes," she said; "will you all
start tea?"
</p>
<p>
"But won't you give me a chance to speak to
you later on?" gasped Graeme, "just for a second.
It isn't anything to do with this wretched business.
I mean I don't want you to marry me just
because——"
</p>
<p>
Miss Mayne turned a tear-wet face towards him
for one instant.  "If you are what I once thought
you were—if you even remotely resemble what I've
always heard of Naval officers, you'll never, never
broach this odious topic again, by word or letter or
implication."
</p>
<p>
And with that she went off along the cliff, walking
very fast with her head bent.
</p>
<p>
Mouldy Jakes fell to buttering a slice of bread.
</p>
<p>
</p>
<p>
<i>Dies irae</i>!  And the night that followed, little
better for most of the participators in that memorable
picnic.  Tears wetted two pillows at least; a third
remained uncreased until the dawn by the head that
ought to have lain there.
</p>
<p>
Cornelius James awoke on the morrow to manifold
perplexities.
</p>
<p>
To Jane, his confidante in most tribulations, he
unburdened himself after an early breakfast, what
time Miss Mayne and Georgina, the former
heavy-lidded and both uncommunicative, were putting
finishing touches to the packing.  The two children
were taking a valedictory stroll round the
farm.
</p>
<p>
"Miss Mayne's been crying," he observed
gloomily.  He abhorred tears.
</p>
<p>
Jane confirmed this with a nod that set her curls
bobbing.  "So's Georgie."
</p>
<p>
"I know."  Cornelius James's tone was one of
exasperation.  "I'm sorry to be leaving Glebe Farm,
but I don't cry about it.  You're sorry, too, aren't
you, Jane?"
</p>
<p>
Jane nodded again, but hesitated before disclosing
the maiden secret of another's breast.  "'Tisn't
that, Georgie wasn't crying 'cos we're leaving,
'xactly."
</p>
<p>
"Then <i>why</i>?" demanded her brother.  He
scrambled on to the wall of the pigsty, and sat
moodily dropping bits of stone on the porker's
back.
</p>
<p>
"You see," explained Jane, not without diffidence,
"she's in love."
</p>
<p>
"What next!" gasped her outraged brother.
"Who's she in love with?"
</p>
<p>
"Mr. Jakes."
</p>
<p>
Cornelius James could find no words applicable to
the situation.
</p>
<p>
"But—but," he finally exclaimed, "even if she
is, what's she got to cry about?"
</p>
<p>
Jane clambered up beside her brother.  "Well,
you see," she began, "it was that picnic."
</p>
<p>
"It was a jolly picnic," maintained the other.
</p>
<p>
"Yes, but Georgie counted on having Mr. Jakes
all to herself on the way back."
</p>
<p>
"So she jolly well did!" commented her brother
wrathfully.
</p>
<p>
"Yes, but he never opened his mouth 'cept once,
and then he only said something about selling a
farm and going to sea, and Georgie thinks he
hates her."
</p>
<p>
Cornelius James pondered over this insight into
the enigma of the feminine heart.
</p>
<p>
"She's an ass!" was his final comment.  "And
what about Miss Mayne?  Don't tell me she's in
love!"  Assuredly the queen could do no wrong nor
stoop to such folly.
</p>
<p>
"I don't know," replied Jane, "but last night
I went to her room to borrow a ribbon to tie my hair
up with 'cos I'd lost mine, an' she was lying on her
bed with her face in her hands.  I thought she had
a headache, and I was going out again when she
jumped up.  Her face was all smeary and her eyes
were red, like when her brother was killed.  'Member?
I per-tended I didn't notice anything, and asked for
the ribbon and she got it from a drawer and gave it
to me without a word, and suddenly she sat down
on the window seat and put her arms round me
and held me against her so tight I could hardly
breathe."
</p>
<p>
The mystified eyes of the brother and sister met.
"But didn't she <i>say</i> anything?" demanded the
former.  "Has anybody been killed she's fond of?"
</p>
<p>
"I don't think so," replied Jane; "she hardly said
anything.  Just whispered little soft words like
'darling.'"
</p>
<p>
"She did that when we tried to cheer her up 'cos
her brother died," said the boy, as if condoning a
lapse on Miss Mayne's part.
</p>
<p>
"Oh, there was one thing," added Jane after
reflection; "she said, 'Oh, Janie, Janie, don't grow
up!'"
</p>
<p>
Which left Cornelius James not much the wiser.
</p>
<p>
To a more sophisticated mind the utterance might
have meant much or little.  For my part I look for
my clue to the riddle in a later remark Miss Mayne
made aloud to the darkness, from off a crumpled
tear-wet pillow.
</p>
<p>
"He never said he loved me," she pleaded.  The
darkness held no answer.
</p>
<p><br/>
<br/>
<br/>
</p>
<p><a id="chap01b"></a></p>
<h2 id="pgepubid00003">
PART TWO
</h2>
<p><br/>
</p>
<h3 id="pgepubid00004">
  THE NARRATIVE OF COMMANDER WILLIAM DALRYMPLE<br/>
  HORNBY, ROYAL NAVY<br/>
</h3>
<p class="t3">
1
</p>
<p>
The ship was doing her annual refit at a Dockyard
Port in the south, and the Captain and I shared what
leave there was going; in my case it amounted to
eight days, and I spent them trout fishing in
Breconshire.  I have tried a good many experiments in the
way of how to make the most of a week's leave, and
I have come to the conclusion that few things take
the taste of war out of a man's mouth as effectively as
whipping a "mountainy" trout stream.
</p>
<p>
It was a long and tedious railway journey back;
I suppose I am as fond of my ship as most
Commanders: she probably means more to me than a
ship does to a man with a wife and bairn of his own,
but I can't say I looked forward to slipping into
harness again after the week's freedom from routine
and responsibility, and the contemplation of returning
to another nine months' exile in the North Sea didn't
add any gaiety to the train journey.  I was uncommonly
glad, therefore, when I changed at Bristol and
walked into Frank Milsom on the platform.
</p>
<p>
He was a "Red" Marine and an old shipmate of
mine in the Mediterranean Flagship 'way back in the
dark ages: one of those born leaders of men, possessing
(although I believe it doesn't always follow) a
curiously magnetic fascination for women.  Yet I
believe women bored him; I remember he once told
me he would as soon kiss a dog as a woman, unless
he was drunk.  He was full of "parlour-tricks,"
too—the things that make a man sought after as a
messmate; he could vamp a comic song and do sleight of
hand conjuring tricks, and he had the most infectious
laugh that ever kept a mouldy wardroom alive.  The
only vice I ever observed in him was a passion for
gambling, but he had a peculiarity which is unusual
in the Navy: we used to say he was "fey."  He had
queer dreams sometimes that used to come true—the
date for paying off and things like that—and on one
occasion I recollect drawing back the curtain of his
cabin on my way down from the middle watch, because
I heard him laughing and wondered who was
with him at that hour.  He was sitting up in his bunk
with the moonlight pouring through the open scuttle,
and his hand stretched out in gesticulation (a way he
had when animated); otherwise the cabin was
empty.  He was wide awake, told me he was talking
to his mother, and cursed me for interrupting.
She was at the time about 2,800 miles away as the
crow flies.
</p>
<p>
He came towards me wheeling a ramshackle
motor-bicycle, with a cocker spaniel on a chain, and
a porter following with his bags and golf clubs.
"Bill Hornby!" he said, and the years between us
and our last meeting seemed to close up like a
telescope.  We climbed into an empty carriage and
settled down in two corners facing each other, lugging
out our pipes and 'baccy pouches preparatory to a
long yarn when, just as the train was starting, there
was a bit of a commotion outside.  A porter jerked
open the door, pitched a woman's dressing-case on
to the seat (we were sitting at the end furthest from
the door), and fumbled for his tip as the owner of
the dressing-case followed.  She was a long-legged,
graceful girl, dressed in tweeds and rather neatly
shod.  Milsom swore softly under his breath when the
dressing-case appeared and stopped filling his pipe.
But presently, when the train had started and our
fellow-passenger had settled down in the corner facing
the engine next to the door and opened a novel,
Milsom leaned forward in his seat and asked her
permission to smoke.
</p>
<p>
Until she was addressed the girl had not shown
that she was aware of our presence in the carriage.
She had not even glanced in our direction, and now,
hearing herself spoken to, she turned a rather pale
face and two almost startled grey eyes towards each
of us in turn.
</p>
<p>
"D'you mind this?" enquired Milsom, in the
kindly tolerant voice in which he spoke to women,
and held out his iniquitous looking briar for her
inspection.
</p>
<p>
The girl shook her head unsmiling.  "Not at all.
I—I——" she glanced swiftly from us to the window
and the obvious
</p>
<p class="capcenter">
<a id="img-060"></a>
<br/>
<img alt="(mirror-image SMOKING)" class="imgcenter" id="id-1142244268503217527" src="6179856497172191502_img-060.jpg"/>
</p>
<p class="noindent">
on the glass panel.  "I beg your pardon," she said.
"I didn't notice.  I was late and the porter hustled
me in——"  She turned her eyes on me; she had
well marked, delicate brows, and a firm chin.
Altogether I thought her a remarkable-looking young
woman (I was sitting with my back to the engine,
facing her diagonally), and had it not been for a
certain touch of diffidence in her rather shy manner,
I should have written her down as decidedly
strong-minded.
</p>
<p>
For a moment she looked as if she were contemplating
flight to the corridors in search of another
carriage.
</p>
<p>
"Train's very full," said Milsom, "but if you like
I'll go and see if there's room in a non-smoker."
</p>
<p>
She shook her head.  "I don't mind smoking—unless
you mind my staying where I am?"
</p>
<p>
We both mumbled polite reassurances, and she
returned to her book, obviously dismissing us
completely from her consciousness.
</p>
<p>
For all our protestations, neither of us was much
at ease after that; we kept up a desultory conversation
for a bit, but we were unaccustomed to having women
near us, and a man can't talk squarely to another man
with a woman in hearing.  So after a bit we gave it up
and retired behind our papers.  I even dozed for a
bit, and must have slept for nearly an hour when I
was awakened by my pipe dropping out of the corner
of my mouth.
</p>
<p>
My eyes, as they opened, rested first on the girl.
She appeared to be sleeping; at all events she was
leaning back with her eyes closed and her book lying
unheeded on her lap.  I glanced at Milsom in front
of me, and found him leaning forward with his elbows
on his knees, staring across the carriage at the window
beside the only vacant corner—that is to say, the one
opposite the girl.  There was a faintly puzzled
expression on his face, and he kept glancing from
the window to the girl.  Then he looked at me with
a queer enigmatic smile.  We neither of us spoke, I
suppose with the idea of not waking our fellow-passenger,
but Milsom presently drew a pencil-case
from the pocket of his waistcoat and scribbled
something on the margin of his newspaper.  This he
handed to me:
</p>
<p>
"Come and sit beside me; don't make a noise."
</p>
<p>
I obeyed rather curiously, and he continued to
study the window.  We had just emerged from a
short tunnel when he wrote again on his paper:
</p>
<p>
"Watch that window and tell me if you can see
anyone's reflection in it."  He indicated with a nod
the window alongside the vacant seat opposite the
girl.
</p>
<p>
I stared and could see nothing but the landscape
and the telegraph poles flicking by.  Then we
plunged into a cutting, and for a moment the sheet
of glass became a mirror.  I felt Milsom grip my arm
hard above the elbow.  "Well?" he breathed.
</p>
<p>
I shook my head, and for the third time he drew
the paper on to his knee and scribbled hard.
</p>
<p>
"Don't tell me you couldn't see that bloke's
reflection?"
</p>
<p>
I frowned at him in hopeless bewilderment.
"What bloke?" I mouthed.
</p>
<p>
He shrugged his shoulders and shook his head
with raised eyebrows, and at that moment the train
began to slow and shudder as the brakes were
applied.
</p>
<p>
"Get back," he whispered, and I resumed my seat
opposite him as the third occupant of the carriage
began to stir her limbs like one awaking from sleep.
</p>
<p>
For the life of me I don't know why, but I had
the feeling that it would be wrong to see her face as
she opened her eyes.  I somehow felt it would be
like listening if she had talked in her sleep.
</p>
<p>
Milsom was collecting his impedimenta.  "Change
here," he said, yawning, and hauled the reluctant
spaniel from under the seat.  "This train goes on to
London.  Heigh-ho!  Who wouldn't sell his little
farm and go to sea?"
</p>
<p>
I was turning to get my rod down from the rack
when I saw the girl give a little start and shoot a
swift interrogatory glance at Milsom over her
shoulder.  It was the first symptom of interest she
had shown in either of us.  But after Milsom and I
had disembarked on to the platform, and the train
began slowly to resume its journey Londonwards, I
saw her knit her handsome brows and stare rather
curiously at Milsom from the window of the moving
train.
</p>
<p>
We stood beside our luggage in silence, watching
the train pass from sight round a distant curve in the
line.
</p>
<p>
Then I turned to Milsom.  "Now," I said, "what
did all those billets doux you wrote me mean?"
</p>
<p>
He looked at me quizzically.  "Sure you saw no
one there?"
</p>
<p>
"What d'you mean—reflected in the window?"
</p>
<p>
He nodded, with a smile hovering about the
corners of his mouth.
</p>
<p>
"No, of course I didn't.  There were only three
of us in the carriage, and from where we were sitting—all
facing the engine—that window couldn't catch
the reflection of any of us.  I've forgotten most of
the optics I ever learned, but I remember enough to
be sure of that."
</p>
<p>
Milsom fingered his moustache.  "I might have
realised——" he said musingly.  He gave an
imperceptible shrug of the shoulders and laughed
softly.
</p>
<p>
I got rather irritated.  "Come on, Soldier," I said.
"For heaven's sake explain, and don't keep on with
this Maskelyne and Devant business."  But he shook
his head, still laughing.  "No," he said, "it's too
good to waste here.  Come and have dinner up at
the Mess to-night and we'll exchange theories.  And
now," he continued, hauling in the slack of the
spaniel's chain, "let's buy a pack of cards and play
picquet.  Our train's due already."
</p>
<p>
The carriage was too full for me to broach the
subject again, and Milsom took thirty shillings out
of me instead.  At our destination we parted: he to
go to the Marine Depôt, where he was Adjutant; I
in a musty four wheeler to the dockyard where the
ship was lying.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
2
</p>
<p>
Milsom greeted me a couple of hours later in the big
oak-panelled hall of the Officers' Mess at the Marine
Headquarters.  I had been on board the ship, had
half an hour's yarn with the Skipper (who was full of
the ways of Dockyard Officials and the tale of our
Defect List), shifted, and got up to the Marines' Mess
as the first dinner bugles were sounding.
</p>
<p>
Every time I enter that hall, with its tattered
Colours hanging from the walls and the portraits of
bygone Commandants staring down over their gorgets,
I am struck afresh by the reminders, cherished
here on all sides, of the proud past of the Corps.
Greenwich Hospital excepted, the Navy has no
shrines where the emblems of its traditions are
preserved, but the Marine Headquarters always seem to
echo with whispers of the Marines' history.  In the
seconds that it took me to cross the wide floor, I had
a blurred vision of the Rock, taken by storm and
held against odds; of haggard, fever-stricken detachments
in rotting pith helmets, fighting their way
through swamp and jungle, of the African sun
catching the reddened bayonets of a desert
square....
</p>
<p>
"Cocktail, I think."  Milsom beckoned to a
waiter, and, slipping his arm through mine, drew me
down beside him on to the high-padded fender of
the old fireplace that is a miracle of carving.  He
had had a game of squash, he explained, and a tub
since his arrival, and felt that he had decidedly earned
a drink.  "Plenty of time," he added as he lit a
cigarette.  "Guest night, and the Colonel's waiting
for a guest!"  We sipped our cocktails, and while
we yarned I studied the gathering all round us on
the look-out for old shipmates and familiar faces.
The Commandant I knew well, a grizzled veteran,
whose skin had been so baked by tropic suns that it
had the appearance of ancient parchment.  He came
towards us for a few minutes' chat, limping slightly
from the effects (so it was said) of a mauling by
a lion in Somaliland, and sat rolling his cigarette
round and round between his fingers and thumb, his
keen old eyes watching the door for his guest.
Markham was there, upright and groomed to the last
hair, and the sight of his face instantly recalled the
vision I always cherish of him astride the wall of a
Chinese fort, plying his sword like a swashbuckler,
and endeavouring to shield the body of an
unconscious N.C.O. from the pikes of the Boxer rabble
below.  Ye gods!  And we called that war!
</p>
<p>
The hall was full, and the guests included a fair
sprinkling of soldiers from neighbouring camps and
a good many N.O.'s from ships in harbour.  At
one end of the room clustered a dozen freshly joined
subalterns: they whispered constrainedly amongst
themselves and eyed the assembly with furtive
interest.  "Straight out of the egg," observed
Milsom.  "Mammy's darlings, every one of 'em.
They shall sing us Songs of Araby after dinner or
I'll eat my hat."  I had my own ideas how Milsom
should amuse himself after dinner, but I said nothing.
"Watch them gloating over Markham and his
V.C."  Markham, according to his kindly nature,
had gone over and was talking to the new-comers.
They clustered round him in the unabashed hero-worship
of youth, their shyness perceptibly evaporating:
clean, robust striplings with down on their
upper lips and the stamp of the Public School plain
upon them.
</p>
<p>
The swing doors opened and the Commandant
tossed away his cigarette and rose as the guest of the
Mess entered.  He was a youthful Colonel of Marines
on leave from the Western Front, a tall, lean man
with a scar across his forehead and the look of
wearied habitual alertness you always see in the faces
of men fresh from the trenches, and also of our patrol
Destroyer Officers.  I had never seen him in the
flesh, though the illustrated papers have by now made
him a familiar figure enough.  For this was Henry
Havelock, destined to wear before he died every
gallantry award in the gift of England and France.
He was a contemporary of Milsom's, and when presently
we adjourned to the vast arched messroom, I
found myself sitting between them at the
Commandant's end of the table.  The talk was war, of
course, because war made up every man's experience
of life for the past three years and a half.  But the
range and variety of the fields which were being
discussed down the shining length of the mahogany
table made it unique.  In one sector it was Antwerp
and the raging inferno that had once been Lierre held
for a live-long night against the headlong onslaught
of the Hun.  In another, Gallipoli held sway, and as
the wine circulated and tongues were loosened, tales
of that splendid failure were told that assuredly will
never find their way into any printed history of the
Great War.  The hum of voices under the old beams
of the vaulted roof was the echo of strife carried from
Serbia to the Cameroons, with Mesopotamia and the
Persian Gulf thrown in.  The only man who
appeared disinclined to talk war was Havelock; he
and Milsom were exchanging pre-war reminiscences
of a visit paid by the Mediterranean Fleet to Monte
Carlo; how a certain lady with an impulsive
temperament lost her heart to the embarrassed Milsom,
who was challenged to a duel by an indignant
husband; this worthy Havelock plied with absinthe until
he (the husband) was all for Havelock running off
with the lady and thus easing a complicated situation;
and as the evening wore on and the assiduous
Corporal of Marines—brooding behind us with a
gold-topped bottle gripped in one white cotton gloved
fist—redoubled his attentions, Havelock's eyes lost
their weary strained expression, and the stern lines
round his mouth relaxed.
</p>
<p>
We had finished dinner and the port had gone
round for the King, and following the second
circulation the Commandant rose, and after a neat little
speech, proposed Havelock's health, which we
drank with musical honours.  Havelock replied,
and in a few brief sentences he sketched the
part played, not by himself but by the Royal Marine
Units at the front under his command.  Listening to
his pithy descriptive rendering into prose of the epic
of Beaumont Hamel, it was not difficult to understand
the magnetic command of men with which he has
been credited, nor the devotion of their willingness to
follow him to the gates of Hell.
</p>
<p>
The Commandant was for snooker after that.
"Are you and your guest going to take a cue?" he
asked Milsom, but Milsom shook his head.  "No.
They'll want me at the piano presently.  Take
Havelock along and some of the others."  So Havelock
and his host departed to gather in a party and
Milsom beckoned for the cigars.
</p>
<p>
"Now," he said, "I promised you a yarn, didn't
I?  Well"—he clipped and lit a cigar—"I've been
thinking about the whole thing, and what I am going
to tell you is partly theory and the rest ain't fact as
you probably understand the term."  He spilt a drop
of water from his finger-bowl on to the shining
surface of the table and sketched an oblong outline with
the end of a burnt match.  "This represents the
carriage we were travelling in this afternoon with that
young woman:
</p>
<p class="capcenter">
<a id="img-069"></a>
<br/>
<img alt="(diagram of carriage seating)" class="imgcenter" id="id-9168034962061096902" src="6179856497172191502_img-069.jpg"/>
</p>
<p class="noindent">
The arrow indicates the direction in which the train
was travelling.  The blobs are you and me opposite
each other, and the other's the girl.  Got that?
Well——"
</p>
<p>
"What's the cross?" I asked.
</p>
<p>
"That's an empty seat.  The symbol is 'X,'
which stands for the unknown.  That's the corridor
on the right.  Now, I was sitting facing the engine—this
is me in the bottom right-hand corner—and from
my seat I could see the window beside X quite
clearly—naturally; and you may have observed that if
something dark is placed between the light and a
sheet of glass, the said sheet of glass becomes to all
intents and purposes a mirror.  The effect, I think,
is increased if the observer is placed at an oblique
angle to the surface of the glass.  In other words,
from where I was sitting I was better able to see a
reflection in the glass than you were."
</p>
<p>
He drained his liqueur glass and puffed reflectively
at his cigar for a few moments.
</p>
<p>
"We were running parallel to a goods train—a
line of big, closed wagons, when I noticed a reflection
in the window beside the blank seat.  I noticed
it because it wasn't—as it ought to have been—your
reflection."
</p>
<p>
I laughed.  "Whose was it—the Devil's?"
</p>
<p>
"No.  A stranger's.  I bent forward to have a
better look at him because I couldn't see very clearly,
when we drew ahead of the goods train and the
reflection vanished."
</p>
<p>
Had it been anyone but Milsom telling the tale I
should have put it down as pure invention, but as I
have hinted Milsom possessed peculiar qualities, and
I grew still more interested.
</p>
<p>
"Go on," I said.
</p>
<p>
"Well, I waited because I knew sooner or later I
should get another chance; any cutting or tunnel we
passed would do the trick.  But up till then I hadn't
somehow connected the thing with the girl.  It didn't
occur to me.  I wasn't interested in her and I ain't
well up on the science of these phenomena.  However,
in a little while we boomed into a tunnel and I
got all I wanted.  It was no one I'd ever seen before,
a dark, thin, rather lugubrious-looking bloke.  He
had his arm through the leather loop thing and his
hand was tied up in bandages."
</p>
<p>
"But do you mean you saw him?" I interrupted.
</p>
<p>
"No, no; his reflection only.  And while I
watched he shook his head and smiled (not a very
gay effort—sort of twisted) and said something; at
least, his lips moved.  Of course I looked instinctively
at the girl then.  She was sitting with her eyes
shut and her head leaning back, but what gave me
the clue was the fact that her lips moved too.  She
was talking to the fellow."
</p>
<p>
My cigar had gone out, and I discovered my
brandy was still untouched.  I nodded, not because
I understood any more clearly, but because I felt that
words would break a spell.
</p>
<p>
"Now my mater—she died a couple of years ago,
bless her dear soul—used to belong to a lot of
societies that deal with phenomena of various kinds.
I don't mean spiritualistic séances and that sort of
humbug, but suggestion and telepathy.  She used to
believe in a thing she called Projection; concentrating
will power upon something until the thought becomes
more or less a material object—like blowing tobacco
smoke into a soap bubble—d'you tumble?"
</p>
<p>
I didn't, but I nodded again.
</p>
<p>
He was hopelessly out of my depth, but I remembered
spending a few days' leave once with Milsom
at his home when we were youngsters, and seeing a
black spot against a white wall upon which his
mother used to concentrate her mind entirely by way
of mental exercise for long periods daily.  She was a
charming, sympathetic woman and, as far as I could
observe, perfectly normal in other respects.
</p>
<p>
"Now if my mother had been sitting in the
carriage she'd have seen the actual figure.  I couldn't
do that, but I'm what they call clairvoyant enough to
see the reflection.  And then we whisked out of the
tunnel, and I got you to come and sit beside her.  I
wanted to see if you could see him and recognise his
face.  As I've said, it was no one I've ever seen
before."
</p>
<p>
I drank my brandy then because I felt I wanted it.
</p>
<p>
"What's it all mean, Soj?  What's projection
and bubbles full of smoke got to do with it?  I'm
a plain sailorman and I don't understand all this
psychic business."
</p>
<p>
Milsom chuckled.  "I don't understand it either,"
he said, "and God knows I don't want to understand
too much.  But this all seems simple enough to me.
The girl was thinking desperately hard about some
fellow—the hum of the wheels and the telegraph
wires have a hypnotic effect upon some temperaments,
and she just unconsciously projected the figure of
the man she was thinking about into the seat opposite
her and in her imagination was having a chat with
him.  She was probably in love with the real
individual and possibly wasn't getting much joy out of
it.  She didn't look happy."
</p>
<p>
Voices from the ante-room were shouting Milsom's
name: someone was strumming the piano.  Milsom
pushed back his chair.
</p>
<p>
"But was he really there, though?" I queried, as
we rose.  The long messroom was empty save for the
waiters and ourselves.  The hubbub in the ante-room
redoubled, and someone started a song.  Milsom
laughed.
</p>
<p>
"How d'you mean?  Of course he wasn't there
really.  Just because you think of someone it doesn't
mean they dump themselves down in front of you.
Think of someone now."
</p>
<p>
I obeyed and stared hard at the portrait of an
ensign of "The Noble Free and Spirited Manchester
Corps of the Marines" hanging opposite.
</p>
<p>
Milsom followed the direction of my eyes.  "That
wasn't a good choice," he said dryly.  "That fellow
has been sitting opposite us for the last half-hour.
Ever since Markham vacated that chair!"
</p>
<p>
It occurred to me that perhaps Milsom had had
all the liqueur brandy to drink that was good for him.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
3
</p>
<p>
It may or may not have been the effect of the old
brandy, but in all the years Milsom and I were
shipmates I never remember him in a mood of such sheer
light-hearted reckless gaiety as that into which he
seemed to slip on the threshold of the antechamber.
</p>
<p>
A sing-song was in progress round the piano, but
on his arrival the group turned and bellowed for "The
Tuppeny Tube."  "The Tuppeny Tube," it must be
explained, was a song of his own invention,
accompanied by a great deal of patter and not a little
horseplay.  In pantomime he herded the Public (the newly
joined subalterns filled the rôle) into an imaginary
overcrowded tube lift, and with clashing fire-irons
imitated the closing and opening of the gates.  His
stentorian bellow of "'Urry up there, step smartly!
Plenty of room in front!" was the gag that presently
involved the Mess and its guests in a furious mêlée
amid overturned card-tables and chairs.  Little did
we guess as we sprawled gasping, breathless with
laughter and exertion, on the leather upholstered
chesterfields, in what grim surroundings many of us
were to hear again and thrill at that slogan.
</p>
<p>
The snooker players, wearied of the decorum of
the billiard room, presently rejoined the remainder,
and in five minutes Milsom, like the Pied Piper of
Hamelin, had them dancing to his music.  I don't
dance: but I leaned over the back of the piano,
sucking my pipe and watching his smiling, half-mocking
face as he swayed dreamily to the music that
tinkled out from underneath his fingers.  His eyes
were puckered up in the smoke of the cigar he kept
screwed into the corner of his mouth, and as he played
I saw him watching with a queer inscrutable smile
the dancers revolving round him, Majors, Captains
and Subalterns, aye and a couple of Colonels, for
Havelock and Markham were footing it with the best
of them.
</p>
<p>
"This room has seen some good jamborees in its
time, Hornby," he said after a while, speaking with
the butt end of the cigar between his teeth.  "I dare
say men have carried worse memories across the Line
than their last night in the old Mess before they
sailed."  He changed into another air, an
old-fashioned valse with a slow haunting melody; the
Bostoners and bunnyhuggers checked and picked up
the altered step.  "I envy you going back to sea," he
went on.  "It's a good life, afloat.  A clean life....
Better'n mucking about ashore with women....
But our turn'll come."
</p>
<p>
"You aren't due for sea yet, are you, Soj?" I
asked.
</p>
<p>
"I ain't <i>due</i>," he said slowly, nodding his head to
the melody.  "The others ain't due, but they're
going ... some day...."
</p>
<p>
"When are you going?"
</p>
<p>
He shrugged his shoulders, and again the tune
changed:
</p>
<p class="poem">
  "With me bundle on me shoulder<br/>
  Sure there's no man could be bolder" ...<br/>
</p>
<p><br/>
</p>
<p>
He raised his voice in song, and the dancers took
up the words till the great hall rang with men's
voices:
</p>
<p class="poem">
  "For I'm off to Philadelphia in the morning."<br/>
</p>
<p><br/>
</p>
<p>
The player brought down his hands in a crash
of bass chords and rose laughing, amid a storm of
protest.
</p>
<p>
"No more.  Fineesh....  Phew!  It's a long
ship, this."
</p>
<p>
Havelock approached us, glass in hand.
"Milsom," he said, "I take that last song as an
augury."
</p>
<p>
"Why?" asked Milsom, smiling.
</p>
<p>
"Well, my old governor—he was a Marine, you
know—told me that they sang that on the last guest
night before the <i>Birkenhead</i> sailed.  The Marines
didn't exactly disgrace themselves in the <i>Birkenhead</i>,
and we'll hope your playing it to-night means the
Corps are going to get another chance to show the
sort of stuff they're made of."
</p>
<p>
It was the first time I'd heard the loss of the
<i>Birkenhead</i> mentioned as other than a disaster: but
that was Havelock's way of looking at things.
</p>
<p>
"They're doing that all day long," said Milsom,
"but I'll add 'Amen!'"
</p>
<p><br/>
<br/>
</p>
<p class="t3">
4
</p>
<p>
We sailed two days later, and I did not see
Milsom again before we left.  He had walked part
of the way back with me when, somewhere in the
sma' hours, that hectic guest night drew to a close.
We parted at the head of a dry dock, where a Light
Cruiser was lying shored up in the midst of an abyss
of shadows, and for a moment Milsom leaned over
the guard rail and stared down the tiers of smooth
masonry into the darkness beneath us.
</p>
<p>
"Hornby," he said, "I wish I had my mother's
clearness of vision.  I feel somehow that you and
I are on the eve of something—an awfully big
adventure of sorts."
</p>
<p>
"I feel it now," went on Milsom, staring down
into the dock with its flights of giant steps of granite,
and speaking in a low voice.  "It's a sort of—sort
of pricking of the thumbs!"  The beam of an
inquisitive searchlight on one of the harbour defences
swung round and for an instant dazzled us, painted
the objects round us ebon and silver, and passed.
Milsom straightened up.  "Stonework and searchlights..."
he said, as if repeating a half-forgotten
lesson.  "Stonework and searchlights and darkness
beneath....  Oh, I wish I knew!  I wish I
knew!"
</p>
<p>
Then abruptly his mood changed.  He broke into
one of his delightful laughs, fetched his right hand
out of his pocket and slapped me on the shoulderblade.
"Sleep well!" he cried.  "Sleep tight—and
don't let the bogies bite!"
</p>
<p>
That was the last I saw of him.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
5
</p>
<p>
We had been back at the Grand Fleet Base nearly
a fortnight, and leave had slipped into the limbo of
the past.  The usual after-effects of a spell at a
dockyard were beginning to be apparent: the married
men were cheering up and the bachelors were showing
feverish interest in the mails.  We had a racing cutter
in training and a gunnery programme under way that
Guns vowed was going to bring him in grey hairs
and sorrow to the grave.  Then one busy morning
when I had mapped out a nice little programme for
myself, the Boatswain and the Captain of the Side
going round the ship in a skiff, the Skipper sent for
me in the after-cabin.
</p>
<p>
"Hornby," he said, "what are your plans for the
future?"  I stared at him a bit.  I'd only been
promoted three years, and I wasn't worrying about
a Command.  I felt I was doing pretty good work
where I was, and the ship, though perhaps I say it
what shouldn't, didn't figure badly in the Squadron
Returns.  However, I decided he was contemplating
a change of Commanders and was sorry, because he
was a White Man.
</p>
<p>
"Plans, sir," I said.  "I don't know that I have
worried much about making plans.  I believe in
going where I'm sent and leaving it at that."
</p>
<p>
He nodded with his dry smile and picked up a
telescope off his desk.  "I know you won't think
I'm butting into your private affairs, Hornby, or
being inquisitive"—he focused the glass through
a port on a distant cutter under sail—"but are you
by any chance thinking of getting married again?"
</p>
<p>
"No," I said.
</p>
<p>
He closed the glass with a snap and faced me
squarely.  "Got any one dependent on you?"
</p>
<p>
I shook my head, wondering what on earth he
was driving at.
</p>
<p>
"Well then, I won't beat about the bush any
more.  There's a certain operation in contemplation
over the other side; a pretty desperate business as
far as I can make out, and the odds against coming
out of it alive are considerable.  A Captain is wanted
to command a certain unit of the force; are you on
for it?"
</p>
<p>
"I'm on for it all right," I replied, "but I'm not
a Captain."
</p>
<p>
"That's all right," said the Skipper.  He looked
at me a bit queerly.  "I was dining with the Admiral
last night and he hinted the nature of the business
and asked me if I thought you'd do.  I told him
you would, but the thing is uncommonly like
signing a very old friend's death warrant.  However,
if you pull through you'll not exactly lose
by it."
</p>
<p>
I suddenly felt a most extraordinary elation, like
a schoolboy promised an unexpected holiday.
</p>
<p>
"Can you give me any details, sir?" I asked.
"Something to go on and make arrangements?"
</p>
<p>
The Owner shook his head, and sitting down at
his desk pulled a signal pad towards him.  "No," he
said, "but I'll make a signal to the Admiral that you
accept and he'll probably send for you in the course
of the day."  He rang the bell as he spoke and
handed the signal to a messenger.
</p>
<p>
"Give that to the Yeoman of the Watch and tell
him to make it to 'Flag.'"  Then he nodded to me.
"That's all then, Commander.  We'll leave it at that
for the present."
</p>
<p>
"Aye, aye, sir," I replied, and so left him,
feeling younger than I had felt for many a long
day.
</p>
<p>
I hadn't long to wait for the summons from the
Flagship.  Barely an hour had elapsed before the
Chief Yeoman stood in the doorway of my cabin.
I was going through the Defaulters' List with the
Master-at-Arms, I remember.
</p>
<p>
"Signal from Flag, sir," said the Chief Yeoman.
"Admiral wishes to see Commander Hornby at once."  He
had evidently shown it to the Officer of the Watch
<i>en route</i>, because as he spoke I heard the pipe of
the Boatswain's Mate shrill along the upper deck,
calling away the picket boat.  I've noticed that
when the gods elect to disturb the course of
human destinies they don't dally long upon the
road.
</p>
<p>
I had a surprise on the threshold of the Great
Man's after cabin.  The Flag Lieutenant ushered me
in and left me on the mat with a murmured "Commander
Hornby, sir."
</p>
<p>
The Admiral was standing with his back to the
empty stove.  Sitting on the arm of a chintz
upholstered sofa, swinging his leg and smoking a
cigarette through a foot-long amber holder, was no
less a person than the Director of Naval Offensives,
whom I, in common with the rest of the Navy,
imagined at that moment to be seated at his desk
in a Whitehall office.
</p>
<p>
"Morning, Hornby," said the Admiral.  "I've got
your Captain's signal.  Very glad to get it.  Just
cast your eye over that chart on the table."
</p>
<p>
From where I was standing I could see it was a
big scale chart of the German coast.  I crossed
the cabin, and the Admiral, who was standing by
the table, bent and placed his forefinger on a
spot half way up the coast.  "See that place,
Hornby?"
</p>
<p>
"Yes," I said, "Angerbad.  The new German
destroyer and submarine base."
</p>
<p>
"That's it," said the man who spent his life
watching it as a cat watches a mouse-hole.  "We
want you to block it...."
</p>
<p>
I confess that caught me in the wind a bit.
</p>
<p>
The Director of Offensives chuckled and blew a
cloud of smoke.  "We'll help you, Hornby," he said.
I think I flushed a bit.  It was the cold insolence, the
calculated madness of the thing that took away my
breath.
</p>
<p>
"Aye, aye, sir," I said, and as I spoke I noted
the red markings scattered about that section of the
coast and clustering thick round the port of Angerbad
till there was not an inch thus unadorned.  Every
mark was a German battery, and the guns ranged
from 15 in. to 3-pounders or thereabouts.
</p>
<p>
"Just give him the outline of the thing," said the
Admiral, and the Director of Offensives got down
from his perch and joined us at the table.  With the
mouthpiece of his cigarette holder he traced the
course of the canal to where it debouches into the
harbour.
</p>
<p>
Our conversation for the ensuing half-hour need
not be recorded here.  It was concerned with ways
and means and a good deal of detail that was
subsequently found impracticable or to require
modification.  But it wasn't very long before I realised
the magnitude of the task ahead of us, and while
he talked the Director of Offensives sat twisted on
the side of the table, enveloped in cigarette smoke,
talking in curt sentences that gave one insight enough
into the icy, almost terrible, intelligence that lay
behind his smooth forehead.  The other occupant of
the cabin spoke but little, pacing slowly to and fro
with bent head, pausing every now and again
to caress the great wolfhound that lay sprawled
across the hearth and never took his eyes off his
master.
</p>
<p>
At length, however, when the broad outlines of
the plan had been unfolded, the Admiral halted in
his walk.
</p>
<p>
"We'll give you an obsolete Cruiser to fit out for
the job, and you'll run her alongside, disembark
the assaulting parties, and bring them off again when
the work's finished.  It's a seaman's job, and we've
picked you to do it."
</p>
<p>
"Thank you, sir," I said, and meant it.
</p>
<p>
"What about the officers and men?" he said.
"My pack want blooding again.  Got any suggestions?"
</p>
<p>
"Yes, sir," I said.  "I know of two I'd like to
see there, and I'd like to take a Lieutenant called
Thorogood as my First Lieutenant; I think I can
answer for his willingness to come."
</p>
<p>
"Well, that can wait for the present," said the
Director of Offensives.  "We've got to get you South
first of all and choose the ships.  Then we'll find
some men to put into 'em.  We want a real Prince
Rupert of a Marine to lead the storming party on the
Mole, and some good subalterns——"  He climbed
stiffly off the table and threw away the stump of his
cigarette.  "Eh!" he said, "why ain't I twenty years
younger!  They didn't do these things when I was
a boy!"
</p>
<p>
I heard the words, but my mind was far away
in the corner of a southern dockyard at night, and
as in a dream I heard Milsom's voice:
</p>
<p>
"Stonework and searchlights....  I wish I knew....
I <i>wish</i> I knew."
</p>
<p>
Ye Gods!  Was this what the bogie in him was
driving at?
</p>
<p>
"I'll wire to the Admiralty for your relief at once,"
said the Admiral, as I withdrew to return to my ship.
"He'll be North in three days, and you can start in
on this business."
</p>
<p>
And so I went out, past the motionless figure of
the Marine sentry in the lobby, to begin an awfully
big adventure.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
6
</p>
<p>
I was sitting in my cabin after dinner writing up
my night order book when Jakes pushed back the
curtain and stepped inside.  I believe in being
accessible, and don't let people knock at my door.
</p>
<p>
"Hullo, Mouldy," I said, "what can I do for you?"
</p>
<p>
He was our Assistant Gunnery Lieutenant, and
he was called Mouldy in the Wardroom on account
of a silent sardonic manner he usually affected.
Popularity is a mysterious thing; no man ever sought
harder to avoid it or achieved it more readily than
our silent "fathom of misery," as the First Lieutenant
affectionately termed him.  I think fellows in a Mess
read character rather well and ignore externals.
Anyhow, for all his dry cynicism, I knew Mouldy to
have an absurdly tender heart, and to be as sensitive
of soul as a soft-shelled egg.  He stood with his cap
under his arm and his hands joined in front of him,
the fingers twisting.
</p>
<p>
"'Speak to you for a minute, sir?" he mumbled.
As a matter of fact, before he introduced the formula
that signifies private affairs, I guessed at the first
glance that Mouldy was in trouble of some sort.  I
nodded at the armchair.
</p>
<p>
"Take a sit-down, old lad," I said, "and
have a cigarette; I shan't be a minute finishing
this."
</p>
<p>
I had been too busy since we returned from leave
to pay much attention to affairs in the Mess.  But
I had observed that Mouldy never seemed to be about,
and when he came to meals appeared even more
taciturn and self-contained than his wont.  I left him
alone for a few minutes and then turned round.  He
was still standing before the door slowly twisting
his fingers.  I got a pipe and began scraping it out.
</p>
<p>
"Cough it up, Mouldy," I said.
</p>
<p>
He cleared his throat.  "It's nothing much, sir,"
he replied, in a rather husky tone of forced
detachment.  "I—I just wanted to say that I thought
I'd—er—rather like to leave the ship."
</p>
<p>
I said nothing, but went on scraping out my pipe.
</p>
<p>
"I don't feel I'm doing much good, sir, an' I
thought I'd like to volunteer for a 'mystery ship,'
or something with a bit of risk attached to it.  I'd
take on anything as long as there was some danger
mixed up with it.  I feel I'm growing moss and
barnacles up here."
</p>
<p>
I didn't altogether like that.  Mouldy was as
brave as anyone I knew, but he was no adventurer
by nature.
</p>
<p>
"Well," I said, "of course the Skipper'll send
your name in if you want me to ask him, but I'd think
it over for a bit if I were you."
</p>
<p>
"I've thought it over," was the reply.  "I've done
nothing else since I came back from sick leave."  He
made a little movement with his damaged hand.
"And I—the fact is, sir, I can't stick it any longer."
</p>
<p>
There was a note in the old thing's voice that
somehow wrung my heart.  There was trouble here, and
my imagination coursed wildly over fields of
improbability.  For an instant I thought of a woman,
but dismissed the idea.  The sort of women that
Mouldy usually bestowed a fleeting affection upon
were not the type to send a man looking for
glory.
</p>
<p>
"Look here," I said, "we've known each other
some years now.  I'm not the man, as you've probably
discovered, to butt into a fellow's private affairs
or worm confidences out of anyone, but if you're
in trouble of any sort, and it would help to get it
off your chest——"
</p>
<p>
He hesitated for an instant, and in that moment
he looked somehow pathetic; awfully young and
boyish and in need of advice.  "I'm a good deal older
than you are, Mouldy," I went on, "and I've been
through my own Valley of the Shadow in my
time."
</p>
<p>
He took a long breath, and for a second I thought
the floodgates were going to be loosed.  Then the
painful reserve and shyness of his nature closed on
the impulse like a vice.  "No, sir," he said, "no
... thanks awfully....  I just wanted to get away
... just that."
</p>
<p>
Whatever fox was gnawing under his shirt, he
preferred to hold on to it rather than another eye
should see his hurt.  Well, I think I liked him all
the better for it.  I never found talking about my
trouble lightened it.  It's a matter of temperament,
I suppose.
</p>
<p>
"Right-o!" I said instantly.  "I'll see what
can be done.  In fact I'll go further.  I'll promise
you all the change and danger and excitement you
could possibly want."  And with that I sent him to
turn in.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
7
</p>
<p>
My relief turned up three days later, and that night
they gave me a farewell dinner in the Wardroom.
It was like all shows of the kind—a mixture of wild
joviality and moments of sentiment, real or stimulated
by the cup.  I had to make a speech, of course, and
altogether was not sorry when it was at last possible
to escape to the Quarter Deck.  I had given no reason
for my abrupt departure from the ship, and I was
conscious that I had succeeded in surrounding myself
with a sort of glamour of mystery.  Bunje (he was
our First Lieutenant then) would have it that I was
about to contract a matrimonial alliance with an
exiled princess, and made a moving speech after
dinner that was not in all its features fit for
reproduction in these pages.
</p>
<p>
The Young Doctor stoutly maintained that I had
decided to embrace Holy Orders, and insisted on
borrowing the Padre's cassock to wear while he
outlined my probable career as a missionary in the valley
of the Yangtse-Kiang.
</p>
<p>
It was Thorogood who joined me on the Quarter
Deck where I was finishing a final pipe before turning
in, and he fell into step beside me, linking His arm
in mine in the boyish, spontaneous manner in which
his affectionate nature revealed itself.
</p>
<p>
"We'll miss you awfully, Commander," he said.
</p>
<p>
"You haven't seen the last of me yet, James,"
I replied.
</p>
<p>
"No," he answered, "but you're off to-morrow,
aren't you?  And God knows when I'll see you
again."
</p>
<p>
"Hang it, why shouldn't I drop him a hint," I
thought.  If the flower of the Service was needed
for this bloody business, then I'd choose Jimmy
Thorogood amongst the bunch.
</p>
<p>
"James," I said, "would you care to come with me
to my next job?"
</p>
<p>
He stopped short and stared at me through the
darkness.  "D'you mean it?" he cried.  "By Jove!
If I thought——"
</p>
<p>
"Listen," I said.  "Its a business that wants
thinking over.  It's a pretty risky affair, and you
are liable to get scuppered.  The odds are a hundred
to one on your being killed.  I can't tell you any
details at present, but think it over.  You're not to
tell a soul, and I'll write to you later and renew my
offer.  I shan't think you a coward if you refuse."  Upon
my soul, at that moment I half hoped he
would refuse.  I was awfully fond of Jimmy Thorogood.
</p>
<p>
"My aunt!" he gasped, just as I had
gasped in the Admiral's cabin in fact.  "How
perfectly <i>topping</i>! ... I say, thanks awfully,
sir!"
</p>
<p>
I left it at that.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
8
</p>
<p>
For the next couple of months I was a busy man.
I made my headquarters ashore, but they gave me
a roving commission, and I spent a good deal of the
time at the Admiralty and paid a lot of flying visits
to Dockyard Ports.  It would take too long to go
into all that part of the business and describe our
hunt round the scrap heaps of the Navy for just
the craft we needed.  I fixed on the old <i>Intolerant</i>
for my share of the business, and I shan't forget the
thrill with which I first saw her, black against the
sunset one evening, lying at her rusty moorings on
the Motherbank.  For the three blockships we selected
the three obsolete Cruisers of the "D" class: <i>Daring</i>,
<i>Dauntless</i>, and <i>Determination</i>, and presently their
Captains arrived down from the North in obedience
to a telegram from the Director of Offensives.  They
invaded my diggings at the Base one forenoon,
tumbling out of a rickety four-wheeler, burdened with
rugs and suitcases, all jabbering at once; James
Thorogood, a contemporary of his called Glegg, and
another Lieutenant-Commander I didn't know,
named Brakespear.  They were in the highest spirits
and loudly demanded food.  I fed them and gave
them drink, and finally, when they had their pipes
alight and were sprawling at their ease, I unfolded
what lay ahead.  Of course, they had an inkling—in
fact, they had to be told a certain amount when
they were asked to volunteer.  But they wanted
details now, and what I told them ought to have
sobered a circus.  Instead of which, Glegg danced a
war dance, and Thorogood solemnly stood on his
head in a corner of the sofa, while Brakespear flung
cushions at him and scared the landlady's cat to the
verge of delirium.
</p>
<p>
It was the next day that I learned for the first
time who was to lead the Marines' storming party
on to the Mole from the deck of the old <i>Intolerant</i>.
I received a telephone message from the Director of
Offensives that he wanted to see me, and accordingly
I went to town and reached his office about noon.
There, studying a roll of aerial photographs through
a magnifying glass at the Admiral's side, was
Milsom.  I somehow felt no surprise, but he raised
his eyebrows and smiled in his half-mocking
whimsical way.
</p>
<p>
"You know each other?" said the Admiral.
"That's all right.  Now what about the demolition
party.  We want a Lieutenant-Commander for that;
a Gunnery man for preference.  Any suggestions,
Hornby?"
</p>
<p>
"Yes," I said.  "Lieutenant-Commander Jakes."  I
named my old ship.
</p>
<p>
He nodded.  "Send for him and let me see him.
In the meanwhile you two had better go and have
a Council of War.  It wouldn't be a bad plan if you
went down and looked at the <i>Intolerant</i> together.
They've started work on her, and as soon as the
living quarters are ready, you, Hornby, can take
up your quarters on board.  Milsom won't need to
for some time yet."  He turned to the Marine.  "You
can pick your men and start in a preliminary training
ashore.  No need to be uncomfortable till you've got
to!  By the way, if you are going down to see the
<i>Intolerant</i> you can take a letter for me to the
Commander-in-Chief.  Just wait while I dictate a few
lines."
</p>
<p>
He pressed a button on his desk, and I carried a
couple of the photographs to the window to get a
better light.  They were photographs of Angerbad,
obtained by our aircraft the previous day, and I
studied them with considerable interest.  The weather
had been bad for reconnaissance of late, and the most
recent photographs I had seen previously were taken
ten days before.  I don't think I heard the door open,
but I did hear Milsom give a funny little gasp behind
me, and I turned to see a girl standing in the doorway.
The light was full in her face, and my heart gave the
most unaccountable jump.  I suppose it was
astonishment, because the new-comer was the girl who had
travelled with us in the train returning from leave—what
now seemed centuries ago.  She didn't appear
to see me, but her eyes, with their curious concentrated
gaze, were levelled on Milsom.  She stood quite
motionless for a moment, and I realised for the first
time that she was very tall.  I am not a short man,
and her startled eyes were level with mine.  A little
half-smile of recognition passed over her face.  Then,
with a slight inclination of her graceful head, she
slipped into a chair, with pencil poised and notebook
on her knee.  The Director, deep in papers that
strewed his desk, dictated a note, smoked half a
cigarette while it was being typed, and signed it.  As
the girl was leaving the room he said: "By the way,
Miss Mayne—Captain Hornby—Colonel Milsom."  The
girl bowed, but Milsom stepped forward.  "We've
met before," he said, and held out his hand.
</p>
<p>
"Yes," said Miss Mayne.  A faint colour came into
her pale face.  She gave him one searching, half-puzzled
look (just such another glance as I intercepted
in the railway carriage), and quietly left the room.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
9
</p>
<p>
Some day I hope a better man than I will write the
story of that grim preparation with its hours of
heartbreaking labour; its disappointments and anticipations,
the close, almost affectionate, intimacy between
officers and men.  "Eat, drink, and be merry" was the
motto of the Force, and those who know the sailorman's
lightheartedness and cheerful oblivion to the
things of the morrow will realise, with a morrow as
uncertain as ours, how care-free was to-day.  As a
psychological study it must have presented strange
and interesting sidelights.  We only had one
punishment—a threat of dismissal from the Force; and I
vow that the dread of the cat in the Navy of old never
produced such a state of discipline as ruled on board
those ancient crowded ships.
</p>
<p>
I got a First Lieutenant appointed, a lad called
Jervis, who, immediately on joining, decided that his
rôle required of him that he should grow a beard with
all speed; as a facial adornment it was not a success,
but regarded as a terrifying war-mask it left little to
be desired.  He was a laughable, lovable soul, a
regular soda-water bottle of fizzing spirits and
optimism, and the men worshipped him.  Selby was our
Navigator, a dry, thoughtful old stick, with eyes that
always seemed full of memories that clung like sheep's
wool along a bramble hedge.  He was one of those
men you never get to know thoroughly, yet who never
make you conscious they are keeping you at arm's
length.  It's a type the Navy breeds prolifically.
Never knowing privacy from earliest youth onwards
has a good deal to do with it.
</p>
<p>
In all the preliminary fitting out, however, the
men who really slaved and on whom so much of the
final success depended were Shorty Casseen, our
Engineer-Lieutenant-Commander, and the Gunnery
Lieutenant, Teigne.  The former found a scrap heap,
and converted it into a set of engines that was not only
to be relied upon to take the ship to Angerbad, but we
rather hoped would also bring her back after an
almighty hammering.  I've often wondered why he
volunteered for the job: he had a little wife he adored
and two bonny kids.  But he came, and he lived
through it, bless him.
</p>
<p>
"Guns" (Teigne) was one of those gunnery
enthusiasts who make you wonder what profession he'd
have chosen if no one had discovered gunpowder.  He
saw the world through telescopic sights, I believe, and
is reputed, on first seeing the large hotel that was a
prominent landmark near where we were then
anchored, to have muttered longingly: "My aunt!
What a target!"
</p>
<p>
Of course, as the time drew near, and we had
rehearsed and drilled to the last gasp of preparedness,
others were added to the complement.  We had a
Padre, a bullet-headed athlete, who before the war was
the parson of a roaring miners' camp in the North.
Not the wife-beater's terror of the Sunday periodicals
to look at, though—a quiet, friendly little chap, with
a way of blinking when he talked, as though the sun
was in his eyes.  But one night in the Mess when we
were having a scrap to keep our spirits up and help
our digestions, he picked me up and threw my twelve
stone about like a rag doll.
</p>
<p>
Jock Macrae was our P.M.O., with two assistants
fresh from some hospital.  For a man who was no
despiser of whisky he had the most iron nerve and
steadiest hand of any "butcher" I've met.  I have
wondered since how many torn and bloody bundles of
humanity owe their lives to his imperturbable pluck
and skill.  He brought a banjo with him, and night
after night he would sit cross-legged on the deck,
plucking at the catgut with those long surgical fingers
of his, and sing old Jacobean ballads to the moon.
</p>
<p>
The blockships were moored not far away from
us, and we organised concerts and dinners that
will always remain vivid in my memory as the
gayest entertainments of the kind I have ever
participated in.
</p>
<p>
I saw little of Mouldy or Milsom during the training
period.  The former was coaching his braves in
the gentle art of demolishing things ashore at the
Base, and the latter was at Headquarters introducing
his band of warriors to the inner mysteries of
bomb-throwing, flame projecting, and similar cults.  Once
or twice I went over to confer with them separately,
and found that, by a curious succession of accidents,
they had never met each other.
</p>
<p>
"Went over twice to see that Marine bloke,"
grumbled Mouldy, seated on a case of explosives
and measuring off some fuse, "and blowed if he
wasn't in Town each time, havin' a frolic; an'
here are we sweatin' our guts out..."  He launched
into a brief description of the activities of his
disciples during the past month.
</p>
<p>
Milsom had a similar grievance.  "What's the
bird's name—the demobilisation expert?" he
inquired.  "Jakes?  Well, I went over to look him up
t'other day; I've never met him, and I thought that,
as we were going over the bags together, we might
meet and have a chin-wag.  Of course, the day I
chose to toil over to the Base he had gone afloat
to try some experiments somewhere, so I came back
none the wiser."
</p>
<p>
"You'll meet as soon as they transfer the forces
on board us," I said.
</p>
<p>
I saw Milsom once more before they all took up
their quarters on board.  It was in Town, and I had
gone up for the last time to set a few private affairs
straight.  I don't worry my solicitor much, and I
think he was genuinely concerned at my "clewing
up" my affairs so thoroughly.  Anyhow, when
the business was over he insisted on taking
me to lunch "somewhere cheerful," as he put
it.  He thought, I suppose, that I was getting
morbid.
</p>
<p>
We lunched at a large crowded restaurant full of
red-tabbed soldiers and pretty women smoking
cigarettes.  I'd rather have gone to the club, but old
Addison was all for this place.  "Brighten you up,
my boy," he said, pouring out the champagne.  It
was at that moment I saw Milsom.  It wasn't so
much seeing him there that surprised me as the
glimpse I got of his companion's profile.  It was
Miss Mayne, and judging by the angle at which
Milsom's head was inclined towards her, and the
grave intentness with which she was listening to
what he had to say, they appeared to know each
other pretty well.  They had finished luncheon, and
she was aimlessly stirring her untasted coffee and
answering Milsom in rare monosyllables, her eyes
on her cup.  Altogether, they didn't appear to be
having a particularly gay time, and in a little while
they rose and threaded their way side by side out
of the babbling overheated room and were lost to
view.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
10
</p>
<p>
I had completed everything I came up to London
to do by 4 P.M., and found on looking up a timetable
at the club that I had just time to get to the
station and catch a train back to the Base.  I got
to the terminus with a few minutes to spare, and
on going to the bookstall to buy something to read
I saw a familiar figure standing beside the stall
turning the pages of a magazine.  It was a Commander
of the Royal Naval Volunteer Reserve, a tough old
yachtsman called Armitage.  I did not know him
well, but I had heard a good deal about him from
Thorogood.  He was well over fifty and was, I
believe, a very rich man.  Yet he spent the first three
years of the war slamming about in the North Sea,
and he was now stationed at the Base in charge of the
Armed Motor Launches.
</p>
<p>
He nodded a greeting at me and gathered a
bundle of papers.  "Going down by this train?"
he said.  "Let's find a carriage together.  I'd like to
have a yarn with you."
</p>
<p>
As luck would have it, we got a carriage to
ourselves, and after we had started and Armitage had
got a gigantic bulldog pipe in full blast, he broached
the topic that was uppermost in the minds of all
of us those days.
</p>
<p>
"It's this blockship business that's been worrying
me," he said.  "Even with the crews cut down
to the bare minimum and disembarking surplus
steaming parties before they get across, there'll be
an awful lot of men on board when they sink themselves."
</p>
<p>
"Yes," I said; "but they've got boats.  They'll
just have to pull across the harbour under cover
of your smoke screen"—the motor launches
were detailed to lay the smoke screen inshore—"and
the Destroyers will pick up the boats outside."
</p>
<p>
Armitage nodded and puffed his enormous pipe.
"That's all right as long as the wind holds.  But
supposing the wind shifts and blows the harbour
clear of smoke?"
</p>
<p>
I was silent.  We all knew there was a possibility
of such a thing happening, but that had been taken
into consideration by the gallant lads who had
volunteered for the job.
</p>
<p>
"I saw the Admiral this morning," continued
Armitage, "after talking it over with some of my
boys.  I told him six motor launches would volunteer
to go inside the harbour and bring off the
blockships' crews."
</p>
<p>
I stared at him.  "But..." I said, "have you
seen the photographs of the place?  There's a
machine-gun about every two yards round the
harbour, to say nothing of any destroyers there may be
moored alongside the Mole.  You'll get smothered
with gunfire at point-blank range before the
blockships are abandoned."
</p>
<p>
"Oh!" he said, "I'm not making out it's a
joy-ride.  Thirty years ago I might have laughed at
it.  Remember," he said, pointing the stem of his
pipe at me.  "I'm not making a proposal that I'm
not going to see through myself.  I'm going to
lead the boats in.  But I feel that it would be wrong
not to have a try at saving some of those gallant
children's lives.  Why," he went on, "I might have
had a son there——"  He broke off and was silent
for a moment, puffing hard as if he were laying one
of his own defensive smoke screens.
</p>
<p>
"We're the R.N.V.R.," he said.  "Remember
that.  We want to show the Navy what we're good
for.  The R.N.V.R.!" he repeated.  "Lord!  I could
tell you tales of the old days.  The <i>Buzzard</i>——"
</p>
<p>
He laughed, a little hard laugh without any mirth
in it.
</p>
<p>
We were silent for a while after that.  My brain
was busy with this new development of the affair,
and I was beginning to see all manner of heroic
possibilities in the proposal.
</p>
<p>
"When a man gets to my age," continued Armitage
presently, "he sees things more clearly
somehow—the things that matter and things that don't.
You get down to bedrock.  Money!  I know something
about that commodity, and just how much
happiness you can buy with it."  He made a little
movement with an empty hand.  "Hope makes for
two-thirds of the happiness of life: hoping for
something you believe God'll be good enough to give
you—something you think you've lived clean enough
to earn.  Maybe you get it, maybe you don't.  But
you just go on hoping something, you know."  He
looked at me with patient, steadfast eyes.  "I want
to be of some use to somebody before my number
goes up.  And if I bring back to his lover some boy
who might otherwise have been buried by a German
funeral party, perhaps I shan't altogether have lived
in vain.
</p>
<p class="poem">
  "'A little hope that when we die<br/>
  We reap our sowing, so—good-bye!"<br/>
</p>
<p class="noindent">
he quoted, smiling.  And I thought his smile was
as pathetic as his words.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
11
</p>
<p>
The storming and demolition parties came on board
one lovely sunny morning—the sort of day that
makes you want to forget there's a war.  They were
two of the finest bodies of men I've ever set eyes
upon, and as I watched them disencumbering
themselves of their arms and accoutrements along the
upper deck, laughing and joking among themselves,
it occurred to me that if blood must be the price
of Admiralty, we were going to pay full measure
of our best.
</p>
<p>
We had a sort of informal Council of War in the
Wardroom during the morning, and the Mess was
crowded to the limits of its capacity with Subalterns
and Lieutenants, smoking and talking nineteen to the
dozen.  Into that Dutch Parliament presently strolled
Mouldy Jakes, and stood a moment in the doorway.
"My word," he ejaculated, "who wouldn't sell his
little farm and go to sea—eh, boys?  Anybody got
a drink to give the Officer in Charge of the
demolition party?"  Someone handed him a cocktail and
his lugubrious face brightened.  It then occurred to
me that he and Milsom had not yet met, and I rose
from my seat on the edge of the table to find the
latter in the crowd.  I discovered him standing
upright by the door staring at Mouldy with
one of his odd, inscrutable smiles, and it struck
me, I remember, that he looked unusually white.
I introduced him and left him yarning over a
drink.
</p>
<p>
We half expected to get our eagerly awaited
signal that night.  The factors of weather, wind and
sea and visibility on which the whole business
depended were favourable enough at noon.  Every
soul committed to the venture was aboard and the
motley force was assembled with steam raised.
Somewhere to the northward of us I knew the supporting
forces, big ships, destroyers, motor launches, and
coastal motor boats were fretting at the leash, and
then, just when our hopes were at their highest, the
wind veered and a nasty sea got up.  We banked our
fires for the night, and for the first time for many
a long day we found we had leisure to think and
talk of other things.  I remember walking up and
down the bridge that night in the windy darkness
with the sparks flying from my pipe, and wondering
what Beth thought about it all, and whether she
was glad....  And presently a form loomed up out
of the darkness and Milsom fell into step beside me.
I had left him playing poker in the Wardroom, and
was rather surprised to see him.  We paced up and
down in silence for a while, and I knew and liked
him so well that he hardly interrupted my train of
thought.
</p>
<p>
"Bill," he said presently, "this is going to
be a hell of a scrap.  I thought the Lancashire
Landing was warm work, but I guess this'll knock
it silly."
</p>
<p>
I grunted assent, and for a while he went on to
talk about the show; how he and Mouldy were going
to lead two rushes simultaneously, and his dispositions
for his machine-gun sections and bombing
parties, and while he talked his cigar glowed red in
the darkness.  As I've said, I was rather a long way
off in my thoughts and wasn't listening to him
properly.
</p>
<p>
"... And we'll light such a candle, Master
Ridley, as by God's Grace——" he broke off,
soberly.  Down in the forecastle a gramophone was
humming the refrain of a popular song, and the
sound floated up to us on the wind.  It was somehow
familiar to me, and I connected it with laughter and
women's voices....  Somewhere aft a soda-water
bottle popped as the cork was drawn.  I remembered
then.  The orchestra had been playing it the day I
lunched with Addison at that restaurant and I'd seen
Milsom....  The incident had gone clean out of
my mind.
</p>
<p>
"By the way," I said, "I forgot till this minute,
but something's reminded me; that girl we travelled
up with in the train that day—Miss Mayne?"
</p>
<p>
"Yes," said Milsom; "what about her?"
</p>
<p>
"I didn't know you knew her."
</p>
<p>
Milsom had got out of step; he shuffled his feet
and picked it up again before replying.
</p>
<p>
"Didn't you?" he said, and glanced sideways
at me.  "Yes," he went on, after a pause, "we got
to know each other rather well.  But how did
you——"
</p>
<p>
I told him about the luncheon at that restaurant,
and how I had seen them.  "Soj," I said, "did you
ever ask her who that—that fellow was?"
</p>
<p>
Milsom was silent for a moment.  "No," he replied
presently.  "I never asked her what his name
was."  We walked the length of the bridge before
he spoke again.  "She told me the story, though;
rather a pitiful little tale.  She was a governess, it
seems.  No people: orphan.  Very little money, and
what there was she gave to an only brother to keep
him in the Guards.  Father's old regiment, don't you
know.  Brother was killed and she eventually learned
shorthand and took on that job at the Admiralty.
Thought she ought to do war work.  But it was while
she was a governess she met this—er—naval officer,
somewhere in the country."
</p>
<p>
"Naval officer, was he?" I interrupted.
</p>
<p>
"Yes, and she—I think she got fond of him....
and she thought he cared for her ... but they had
a row....  It sounds as if he was that sort of
fellow who would make a mess of it.  Anyhow, he
mucked up the whole business and went back to
sea and never wrote again ... or anything."  Milsom
pitched the glowing stump of his cigar
overboard.  "And he'll never have her now."  There
was a hard note in my companion's voice I'd never
heard there before.
</p>
<p>
I reflected.  "But," I said, "couldn't you find
out his name?  If it was only a silly misunderstanding
between two kids, we might have helped."
</p>
<p>
"He wasn't a kid."  Milsom halted at the head
of the ladder.  "And as to helping him, ... I don't
know that I wanted to—particularly," and with that
he descended the ladder, leaving me staring after
him in the darkness.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
12
</p>
<p>
Hopes ran high with the rising of the sun next
morning.  The wind was light and steady, and the
sea, as the morning wore on, grew calm as a mill
pond.
</p>
<p>
About noon the signal came through, and by five
o'clock we were aweigh.
</p>
<p>
It is difficult now, after all the momentous
happenings of the ensuing twelve hours, to recapture
precisely one's sensations as we sighted the escorting
Destroyers and Motor Launches sweeping down
to meet us, and forming up on either wing as our
little column, <i>Intolerant</i>, <i>Daring</i>, <i>Dauntless</i>, and
<i>Determination</i>, fell into line ahead.  A squadron of
'planes hummed overhead, searching the sky for
signs of inquisitive aircraft, and louder than that
resonant sound was the deep drone of men's voices on
the decks below, talking amongst themselves.  We
were committed at last to the bravest adventure that
ever caused a man to tighten his girths and roll up
the sleeve of his sword arm, and as I looked up from
the binnacle, across the broad expanse of water, and
saw that doughty array spread out beneath the
afternoon sunlight, I thought that a man might choose
worse company than this in which to fight his last
fight.  Shorty Casseen came up presently and stood
beside me whistling a little tune between his teeth.
</p>
<p>
"How are the bulgines heaving round, old lad?"
I asked.
</p>
<p>
"Fine," he replied.  "She's going as well as
she did when I was an Engineer-Sub and tinkered that
scrap-heap through a Commission in the Pacific.  But
don't you worry, sir," he said, with one of his
bird-like sidelong glances, "we'll get the old hooker
alongside that Mole if the bottom drops out of
her."
</p>
<p>
In so saying, I think he somehow voiced the feeling
that was predominant in all our hearts.
</p>
<p>
The Padre held a sort of informal service later,
on the upper deck, which was attended by all who
could be spared from their duties.  The light was
fading from the sky, and the violet shadows of evening
were closing in on us.  The men's faces, as they
stood bareheaded and intent upon his words, were
whitely visible from the bridge.
</p>
<p>
The attack was timed for midnight but it was
half an hour before that when we saw the first gleam
of star-shell that betrayed an apprehensive spirit
amongst the Boches.  Our Coastal Motor Boats and
Motor Launches had been at work some time, and
were weaving their curtains of artificial fog to and
fro across the harbour mouth.  We heard the
occasional distant boom of a gun, but nothing that
betokened a bombardment or that the enemy had any
real inkling of what was afoot.  One by one we
picked up the mark buoys that had been laid since
dark by the dauntless C.M.B.'s.
</p>
<p>
The moments passed, and the tension grew with
every muffled throb of the engines.  The batteries
were crowded with silent men, and the starlight
gleamed on their steel helmets and here and there a
naked bayonet.  Somewhere in front of those densely
packed ranks were Milsom and his six Subalterns
and Mouldy Jakes, his impassive features hidden by
a gas mask.  He had donned it some time previously,
and persisted in wearing it "as a type of English
beauty," he said, and shook hands in silence before
he went to his post.  Milsom and I had a few words
outside the flame-thrower's hut a little while after
that.
</p>
<p>
"I knew of this show before you did, Hornby,"
he said laughingly, as he broke open a packet of
revolver ammunition.  "D'you remember that night
in the Dockyard when we said good night?"
</p>
<p>
"Yes," I said.  "'Stonework and searchlights.'"
</p>
<p>
"That's it.  It puzzled me at the time, but I'll
know all about it in a little while.  And the rest——"
</p>
<p>
He shrugged his shoulders.  "Who can tell?  It's
written somewhere, I suppose?
</p>
<p class="poem">
  "'Nor all thy piety and wit<br/>
  Shall lure it back to cancel half a line,<br/>
  Nor all thy tears wash out a word of it.'<br/>
</p>
<p class="noindent">
"Well, I'll send a Boche or two ahead of me to
pipe the side before I step over it.  And if I come
back"—he gave one of his reckless devil-may-care
laughs (the laugh I once heard him give when he
flung his last louis on the table at Monte Carlo)—"faith,
Bill, you shall foot it at my wedding...."
He turned abruptly on his heel, and as he strode
away I heard him humming:
</p>
<p class="poem">
  "Wid me bundle on me shoulder,<br/>
  Sure there's no man could be bolder...."<br/>
</p>
<p><br/>
</p>
<p>
At the prearranged point we shifted from the
bridge; the Navigator and Quartermaster moved into
the conning tower, and I took up my position in the
port flame-thrower's hut from where I conned the
ship.  I had previously been round the gun and
howitzer positions, and exchanged a few words with
the waiting officers and men, and as I passed from
one motionless group to the other my heart swelled
with pride and love for them.  There wasn't an
anxious face or a wavering eye.  Broad grins and
whispered jests, like children waiting for the curtain
to go up at a pantomime; and among the Marines
grouped in the rear of each brow some whispered
catchword of Milsom's was rife.
</p>
<p>
"'Urry up there, please!  Step smartly, plenty of
room in the front...."
</p>
<p>
Gallant, gallant lads!  And astern of us in the
quiet darkness lay England—England lighting its
candles and going to bed; England bending over
cradles; and here and there, beside some open window
that looked out to the sea, perhaps some English
girl kneeling and praying as she never prayed
before.
</p>
<p>
A guttering smoke buoy went down our port side,
and the next moment we were enveloped in the
artificial fog of our own making.  We had parted
company from the Destroyers some minutes before, and
the blockships had swerved aside to make the
entrance.  Then, as I stood with my hand on the key
of the fire gongs, peering ahead into the swirling
murk, I felt a breath of damp air blow strong in my
face.  The wind had changed and was rolling back
our fog on top of us.  Like magic I saw a space of
water clear ahead, and the next instant the Mole
stood out black and distinct a couple of cables away,
limned against the glare of searchlights and star
shell.
</p>
<p>
There was a blinding yellow flash—it seemed on
top of us; and that instant, as the old ship answered
to her helm, hell was unloosed.
</p>
<p>
Every gun and howitzer on board opened fire with
a roar that shook the ship from bridge to keel.  The
machine-guns in the top broke into a hysterical
chatter, and all along the Mole bursts of flame
belched forth.  The shrapnel was spattering about
the upperworks like hailstones, and as I got the bows
round, heading for the Mole, I felt the ship check
and shudder as a heavy shell struck her.  Another
burst aft and again another; they must have struck
us in the battery where all those men were waiting,
and try as I would I could not shut out of my
consciousness the thought of the carnage that they must
have caused.  The foremost howitzer gun's crew were
lying in heaps round the gun, and as they rolled
over fresh men came running and stumbling over the
dead to take their places.  The tide was flooding
strong, and the ground swell of yesterday's breeze
broke ominously against the stonework.  The ship
lifted her bows to it, and plunging and scending,
we grated alongside.  I left the shelter of the hut then
and got out on to the bridge to superintend the
placing of the grappling anchors.  Three of the brows
were out, rising and falling above the parapet of the
Mole as the ship lurched in the swell; at one moment
they were six feet above the level of the stonework,
the next they were striking it with a shuddering jar.
And as I watched I saw Milsom and Mouldy go
lurching out along them with their men at their
heels.  A dazzling star shell lit the scene like day,
and I saw Milsom stoop and vault a clear drop of
six feet, turn and catch a burly Marine in his arms,
and rush forward to help secure the grappling
anchor.  They had got another brow out by now,
and men were pouring over it with scaling ladders.
The din surpassed all description.  The almost
ceaseless roar of guns, the grinding and crash of the
brows, the sob of the waves as they broke against
the pier, flinging the spray high, and ever and anon
the explosion of shrapnel overhead spattering their
deadly hail broadcast.  Our monitors and aircraft
were busy, too, and ashore the tall flames of a score of
great conflagrations leaped into the sky.
</p>
<p>
It must be explained that the outer pathway
along the top of the Mole was about six feet wide.
Then came a drop of 30 feet on to the Mole itself,
and once they passed over into this abyss both
storming and demolition parties were lost to view.  They
took ladders for the purposes of this descent, and
the sight of those reeling brows a-swarm with
men, laden as they were with these ladders,
flamethrowers, machine-guns, bombs, cutlasses, and
demolition implements, will always haunt me.  They
dropped like flies, to lie where they fell, dangling
across the narrow gangways or clinging piteously
for a moment ere they let go and slipped into
oblivion.  The forecastle was just a battered heap of
dead and shattered wreckage, and aft along the
batteries I saw Jock Macrae's assistants bending among
the motionless heaps and rushing the wounded below.
</p>
<p>
The Pilot joined me after a while, and together
we watched the blockships pass through the entrance
a few cables away, vomiting flashes and spurts of
heavy and machine-gun fire.  How they got across
that harbour, lit like day by searchlights, whipped
into a sheet of foam by shrapnel and machine-gun
fire, only God and their Captains know.  We saw
Jimmy Thorogood in the <i>Dauntless</i> go crashing
through the flimsy anti-submarine defences, and I
believe we gave him a crazy, cracked cheer.  They
were plastering him with gas shell, and he was on
fire aft and blazing like a hay-rick.  But he held
on and made the entrance to the Canal, and was lost
to view behind some sheds.  <i>Daring</i> came next, and
<i>Determination</i>, trailing in the rear and almost hidden
by waterspouts of falling shell.  And then Selby
gripped my arm and pointed to the foremost
brow.  Our Padre was lurching along it with
splinters flying all round him, looking for all
the world like a tightrope walker learning his
profession.  He reached the Mole intact, and stood
looking about him.  Then suddenly bending down,
he swung the unconscious form of a giant Marine
over his shoulder, and carrying him thus, turned
and retraced his steps.  Other matters claimed my
attention for the moment, but when I next looked
along the ship's side I saw him returning with
another precious human freight slung on his
back.
</p>
<p>
It was impossible to tell what was going on along
the causeway below the parapet of the Mole.  Twice
with a deafening concussion a great sheet of flame
leaped into the air, and I came to the conclusion that
Mouldy's merry men had "touched off" something.
It was afterwards, when we came to piece together
the breathless narratives of those who returned,
that we, whose business it was only to stand and
wait, learned something of that desperate
hand-to-hand righting; of the rushing and bombing of
the machine-guns and a Destroyer alongside; the
destruction of the seaplane sheds; and the yelling
bayonet charge Milsom led against the angry
reinforcements of the Huns.
</p>
<p>
From where I stood I could see the whole panorama
of the harbour in that unearthly light.  I saw
the blockships lying athwart in the entrance to the
Canal, blocking it effectually; I saw the Motor
Launches, led by old Armitage, dashing through
that hellish barrage of machine-gun fire and
pom-poms, and run alongside to embark the crews, turn
and race blindly for the harbour mouth and safety;
and then, when the last was clear, our work was
done.
</p>
<p>
I seized the lanyard of the syren and tugged it,
and shrill above the ceaseless uproar rose the hoot
of the "Recall."
</p>
<p>
According to the arrangements we had made
beforehand, the demolition party retired first, while
the Marines covered the retreat, and no sooner
had the first reluctant figures begun to struggle
back across the shattered brows than the enemy
concentrated every gun he could bring to bear
upon the crowded scaling ladders and the gangways.
</p>
<p>
Fountains of flame and sparks flew skywards,
through which the forms of men came stumbling,
each living figure that reached our deck, it seemed
to me, the embodiment of a miracle.  The planking
flew about me as chips fly from a woodman's axe.
My cap was torn from my head, my monkey-jacket
was ripped and scorched, but there wasn't a scratch
on my body that I was conscious of.
</p>
<p>
I saw my First Lieutenant forward busy about
the slip of the cable; I saw the top above me
shattered by a shell, and after a silence heard the
pom-pom there break out again undismayed.  The upper
deck was a reeking shambles, with men pouring down
into it from the Mole, exhausted, bloody, and
triumphant.  Nearly every man carried a wounded mate slung
across his back, and most of them had a chunk of
masonry or a fragment of shell gripped in his fist
to bring back as a "souvenir" of the night's work—as
if their memories or those of their children's
children needed any such reminder.
</p>
<p>
The Marines fell back at length, and the last to
embark was Milsom, one arm hanging limp and
bloody.  He laughed as he saw me.
</p>
<p>
"Thank God you're all right," he panted.
</p>
<p>
"Ditto," I shouted.
</p>
<p>
"The Devil looks after his own," he said, and
then the business of getting clear claimed all my
attention.
</p>
<p>
We got out of range of their batteries, and the
last fire on board extinguished before we stopped to
transfer our wounded to some of the Destroyers, to be
rushed back to the Base.  A battered Motor Launch
came alongside and I recognised the number painted
on her bows.  It was Armitage's boat.  I went to the
gangway and hailed her.  A Volunteer Reserve Sub. with
a bandage round his smoke-begrimed face,
standing by the wheel, raised his arm.
</p>
<p>
"Armitage?" I shouted.  The boy shook his
head and climbed inboard.  They were passing the
wounded down to be transferred to one of the
Destroyers laying off.
</p>
<p>
"Where is he?" I asked.  The youngster jerked
his thumb towards the launch's tiny cabin.  "Aft,"
he said, in the dull tone of utter exhaustion of body
and emotions.
</p>
<p>
"Five times he was hit an' he wouldn't budge....
Kneeling in a pool of blood for'ard givin'
directions....  Got the last man from <i>Determination</i>
aboard and he said 'Finish,' and rolled over in
a heap.  Just that one word, 'Finish.'"  The dead
man's second in command stood with his face
working.  "Oh, God!" he said; "he was a man, he
was a man!"
</p>
<p>
We resumed our voyage with four Destroyers to
screen us, and the dawn broke chill and wan; a
mist closed down upon us like a pall as the light
strengthened.
</p>
<p>
Jervis was below having a wounded eye dressed
and I was alone, but for the Quartermaster, on the
wreckage of the bridge; but presently I saw Milsom,
with a bandaged arm in splints and a cigar stuck
truculently in the corner of his mouth, climbing stiffly
up the ladder.
</p>
<p>
"Jakes is all right," he said, as he joined me beside
the rail.
</p>
<p>
"Yes," I said.  "Hasn't got a scratch.  Only got
a sniff of gas—but he'll shake that off in a few hours.
The Destroyers say that those Motor Launches saved
all the officers and most of the men from the
blockships.  How's the arm?"
</p>
<p>
"Bit stiff.  Broken in two places."  Milsom
leaned against the rail and took a deep breath.  "But
I'm still alive."  He repeated the sentence and stared
at the dim outline of one of our escort just visible
through the mist.  His tone was like that of a man
awakening from sleep.  "Oh, damn it!" he said.  "No,
no," ... and then he turned abruptly and faced me.
"Look here, Bill," he said, "I was going to play the
rottenest trick a man ever was tempted to stoop to."  He
was talking as if he was in a desperate hurry, the
words coming in a rush.  "This is a funny time to
tell a love story, in all conscience, but I—I—d'you
remember that girl, Miss Mayne?  I've never looked
at a woman in my life till I saw her.  She wasn't
in love with me, but I made her say she'd marry
me....
</p>
<p>
"Oh, I understand her, Bill, as no other man alive
could....  I tell you, I could read every thought
that was in her head—and knowing that, I was going
to take her.  I told myself I had every right to if I
could, and she was mine—just made for me, body and
mind and soul.  I'm telling you this now—you've
never heard me talk like this before, Bill, and God
knows you never will again....  Don't stare like that,
old thing.  I'm not light-headed—I'm telling you all
this, because I—I know who the other man is.  You've
got to help him find her again and patch up their
silly squabble and make her happy—happier than
ever I could.  And I understood her better five minutes
after I'd first set eyes on her than he will with
her lying in his arms——"
</p>
<p>
Somewhere at the back of my brain I heard a far-off
drone like the sound of a distant beehive.
</p>
<p>
"Well," I said.  "What's his name?"
</p>
<p>
Milsom stood staring past me into the mist that
lowered over us.
</p>
<p>
"I'll tell you," he said, "because I——"
</p>
<p>
The events of the next few seconds will always
remain a blur in my memory; the bark of a high-angle
gun from one of the Destroyers astern cut short his
words.  The drone above us seemed suddenly to become
a rushing roar of sound, and a blast of machine-gun
fire swept the deck and bridge as a flight of
seaplanes whizzed overhead flying low, so that I could
see the goggled faces of the pilots behind the spurts of
flame from their guns.  The next instant they were
gone again in the mist.  It was the last sting from
the hornets' nest we had been burning out, and
Milsom was at my feet leaning on his one arm and
staring stupidly at the thin dark stream trickling
across the planking.  The Destroyers on our beam
were firing fruitlessly into the mist.
</p>
<p>
I bent and put my arms about him and he turned
his face towards me.  Twice he tried to speak, and
an attempt at a smile, a ghost of the old jaunty smile,
flitted across his grey face.  He made one more
supreme effort, and with my ear to the bloody lips I
just caught the last whispered breath that took his
soul with it.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
13
</p>
<p>
We passed up harbour to our berth alongside the
following afternoon, and every craft in harbour
manned ship and gave us a cheer while the tugs and
ferry craft hooted, and the folk ashore lined the beach
and waved flags and handkerchiefs.  I am not ashamed
to own that I saw it all through a blur; and as the
off-shore wind carried the thin sound of women's
voices, I couldn't help thinking of the lads below the
shattered upper deck, who had fallen asleep that England
on the morrow might wake to a fuller realisation
of her glory.
</p>
<p>
We dined together that night in the coffee room
of the big hotel that had been converted into the
Naval Headquarters of the Base.  We had counted
on having a tremendous jamboree—those of us who
returned.  But somehow the feeling that predominated
was a sort of dazed astonishment that we were
still alive.  And our heads ached "fit to split" as
housemaids say.
</p>
<p>
Mouldy was in bed, recovering from a slight
gassing, but Thorogood sat next to me, squeezing my
arm at intervals as if to reassure himself that he
wasn't dreaming; and on the other a big subaltern
of Marines who seemed to regard his recent experiences
with less emotion that the last Army <i>v.</i> Navy
rugger match, in which I saw him play.  Glegg was
there with a bandage over one eye, but Brakespear
was in hospital with a piece of shrapnel somewhere in
his anatomy.
</p>
<p>
Jervis had shorn his beard, and in the process
seemed to have parted with something of his
effervescent vivacity, and when I remembered him as I
had last seen him, as we shoved off from the
blazing Mole, stumbling amid the dead and bawling
through his megaphone....  No, we weren't feeling
gay.
</p>
<p>
It was after dinner that we got really talking.
There must have been a dozen of us altogether,
because Shorty had gone home to his wife, and Selby
had gone Home too: a longer journey, but perhaps
an even happier meeting at the end of it....
Anyhow, there were about a dozen of us that lit cigars
and cigarettes and put our elbows on the table,
and the scene, as I remember it, was just
like some big family happily reunited, with the
shadow of the Angel's wing still hovering over
all.
</p>
<p>
Messengers were coming and going all the while
with signals and telegrams, and presently the orderly
murmured, "The Director of Offensives, sir, wants
to talk to you on the telephone."
</p>
<p>
I went up to the room I used as an office when
ashore, and as I picked up the receiver of the
Admiralty line, heard the Director's voice faintly,
speaking not to me but to someone in his room.
</p>
<p>
"Tell them I'll be at the War Office at 3 P.M. for
that meeting ... that's all for to-night, Miss Mayne,"
I heard him say.  Then clearer and louder, "Hallo,
that you, Hornby?"
</p>
<p>
"Yes, sir," I said.
</p>
<p>
"Well, I'm damned glad to hear it."  Then he
said a lot of nice things about what we'd done and
being proud of us, and finished off: "Well, I'd like
to see you at 3.30 P.M. to-morrow if you can get to
town by then."
</p>
<p>
"Aye, aye, sir," and as I answered a thought
flashed through my brain: it was one of those brilliant
inspirations that come once in a lifetime, and in
the course of a sleepless night (none of us slept that
night) I perfected it into a piece of strategy for which
I claim, in all modesty, a place in this already unduly
prolonged narrative.
</p>
<p>
Mouldy occupied a spare room at my diggings
where most of us were billeted for the night, and when
I turned out the following morning, I visited him.
I found him drinking tea and reading the morning,
paper.
</p>
<p>
"How d'you feel?" I asked.
</p>
<p>
He pointed to a tin of cigarettes with a wry face.
</p>
<p>
"Dead off baccy," he said lugubriously.
</p>
<p>
"Well," I replied, "that'll do you no harm.  All
right otherwise?"
</p>
<p>
He nodded.  "All right last night.  Lord knows
why I should have been rammed into bed while all
you pirates lapped up bubbly and made a night of
it."
</p>
<p>
"Doctor's orders.  Anyhow, he says you can go
to town to-day."
</p>
<p>
Mouldy sat up.  "Damn good of him, 'cos I was
goin', anyhow.  I'm going to have a hell of a
jamboree."  He blinked at me defiantly from under a
lank lock of black hair.
</p>
<p>
"You've got to come with me to the Admiralty at
three o'clock," I said as sternly as I could.  Mouldy
groaned.
</p>
<p>
"Have I got to keep sober till three—an' pubs
closing at half-past two?"
</p>
<p>
"Yes," I said.  "You won't have a drink till the
evening—and then you can have as many as you
want."
</p>
<p>
He acquiesced reluctantly, and we caught a train
to town that landed us at the terminus shortly before
three; thence we taxied to Whitehall.
</p>
<p>
"This place gives me the holy pip," said Mouldy,
as we threaded our way through the stuffy-smelling
corridors of the Admiralty.  "Looks as if the Navy
was run by women from what I can see of the place.
Phew!  Shockin' frowst!"  We reached the Director's room.
</p>
<p>
"Never mind that," I said, and opened the door.
I breathed a sigh of relief to find the room was empty,
and glanced at my watch.  It was ten minutes past
three.  Well, if Mouldy couldn't fix things in
twenty minutes....  He walked to the open
window and stood staring out on the Horse Guards
Parade.
</p>
<p>
"Humph!" he observed moodily.  "I reckon the
bounding blue's good enough for me.... I wouldn't
come and work here for a thousand a year.  What
the blazes does the Director want to see me for,
anyway?  He's all adrift too."
</p>
<p>
I was hunting about on the paper-strewn desk for
the bell press I knew was there if I could find it.
There were three: one marked "Secretary," another
"Messenger," and a third "Stenographer."  I took a
long breath and pressed the third.
</p>
<p>
"Mouldy," I said, "don't get into mischief.  Wait
here till I come back.  I shan't be a minute."  Then
I made tracks for the door.
</p>
<p>
In the semi-gloom of the passage outside a tall
girl brushed past me and entered the room, pencil
and notebook in hand.  It was Miss Mayne, and I
waited till the door closed before I looked at my
watch.  "I'll give them two minutes," I thought.
"And if she doesn't come back——"
</p>
<p>
I gave them ten minutes, as a matter of fact, then
I knocked at the door and went in.
</p>
<p>
"Mouldy," I said, "you needn't wait.  It's all
right.  I mean, the Director doesn't want to see you
after all."
</p>
<p>
They had not apparently heard my knock, because
Miss Mayne's head was resting on Mouldy's
shoulder, and he was stroking her hair with his
damaged hand.  She was crying softly, with her
cheek against his coat.
</p>
<p>
Mouldy raised his head and glared at me over
Miss Mayne's shoulder.  She neither moved nor
turned her head.
</p>
<p>
"Here," he said, "you <i>'op</i> it!"
</p>
<p>
I went out into the corridor, closing the door softly
behind me.
</p>
<p>
Then for the Erst time since we landed I felt tired—more
tired than I had ever felt in my life before.
</p>
<p><br/>
<br/>
</p>
<p class="t3">
AUTHOR'S NOTE
</p>
<p>
<i>For purposes of fiction, only the broad outlines of a
great achievement have been sketched into this story;
and no attempt has been made to reproduce faithfully
the strategy or events of St. George's Day, </i>1918<i>.
Indeed, only such ships find their replicas here as the
turning-circle of the tale allows, and if the Author
has anywhere endeavoured to be true to facts, it is
in the portrayal of those fearsome and bloody
conditions under which the Navy added so fair a page to
History.</i>
</p>
<p><br/>
<br/>
<br/>
</p>
<p><a id="chap0201"></a></p>
<h2 id="pgepubid00005">
II
<br/>
<br/>
BEHIND THE VEIL:
<br/>
<br/>
THE STORY OF THE Q BOATS
</h2>
<p class="t3">
(1918)
</p>
<h3 id="pgepubid00006">
1
<br/>
<br/>
FIRST BLOOD
</h3>
<p>
There was a day, now happily past, when the
submarine scourge was broadcast upon the seas; then
the country turned for its salvation to the Navy,
upon which, under the good providence of God, it
had grown accustomed to rely in most of the crises
of its history.  Scientific and mechanical appliances,
on a scale adequate to meet and checkmate the outrage
of unrestricted submarine warfare, could not be
produced by pressing a button.  With workshops and
laboratories yielding their output at highest pressure,
the German submarine building yards were gaining in
the race.  Every day brought its sickening tale of
sinking and burning and murder on the high seas, and in
Whitehall offices men studied statistics and columns
of figures with faces ever growing graver.
</p>
<p>
The irritable tension of those days is best forgotten
now.  Prices rose, ships sank, and the Navy said not
a word.  It was "doing its damnedest" in silence,
according to its wont.  And not even in forecastle or
Wardroom did men so much as whisper what was
afoot.  To-day* the submarine remains merely as a
stern corrective, curbing waste and extravagance,
bracing the nation's nerve.  The ingenuity of man is
boundless, and science has not yet said her last word;
human courage and devoted valour alone seem to
have reached a point there is no transcending.  It
was these two factors which stemmed the flood at
the moment of supreme crisis; on these the veil is at
last lifted, and the tale now told in all simplicity and
truth.
</p>
<p>
</p>
<p>
* Written in August, 1918.
</p>
<p>
</p>
<p>
The methods of the German submarine in its war
against unarmed shipping gradually settled down to
a routine which varied but little in the early phases
of the conflict.  It was the custom to attempt to torpedo
at sight, on the principle of the least said the soonest
mended.  If the torpedo missed, as was not infrequently
the case, the submarine broke surface a mile
or so away from the ship and fired a shot across her
bows.  The merchantman had then two alternatives:
to take to his heels and try to escape, or to heave to
and abandon ship.  In the latter case the submarine
closed the derelict to within a few hundred yards and
summoned the boats alongside.  At the muzzle of a
revolver the Captain was ordered into the submarine
with his papers, and the crew of his boat directed to
row a party of German sailors, bearing bombs, back
to the ship.  These worthies, having placed the
bombs in the ship's vitals and looted the officers'
quarters, returned to the submarine, propelled by the
men they had robbed and whose ship they were
engaged in sinking.  In due course the bombs
exploded and the ship disappeared.  It was an
economical method, since bombs cost less than
torpedoes, and the formality of looting the ship helped
to preserve its popularity.
</p>
<p>
For a while the Navy noted these methods and the
little human failings of the enemy in silence.  Then
it drew a deep breath and made its plans accordingly.
It argued that a man-of-war could be disguised
as a tramp steamer and carry concealed armament.
Such a vessel, by plying on the trade routes,
must inevitably meet a submarine in time, and
in her character of peaceful merchantman be ordered
to abandon ship.  The ship might be abandoned
to all outward appearances, but still retain
sufficient men concealed on board to fight the hidden
guns when the moment came for her to cast disguise
to the winds and hoist the White Ensign.  Certain
risks had to be taken for granted, of course; the
almost inevitable torpedo sooner or later, the
probability of a little indiscriminate shelling while the
submarine approached, the possibility of being
ultimately sunk before assistance could arrive.  Yet the
odds were on the submarine being sunk first, and the
rest was on the knees of the gods.
</p>
<p>
An old collier of some 2,000 tons was selected from
among the shipping at the disposal of the Admiralty
and taken to a Dockyard port, where she unostentatiously
underwent certain structural alterations.  These
included disappearing mountings for guns concealed
beneath hatchway covers, and masked by deck-houses
which collapsed like cards at a jerk of a lever.  From
the host of volunteers, among whom were retired
Admirals, Captains, Commanders, and Lieutenants
of the Royal Navy, a young Lieutenant-Commander
was selected and appointed in command.  His
officers were volunteers from the Royal Naval
Reserve, ex-merchant seamen, familiar enough with the
rôle they were required to play, and in some cases
with little mental scores of their own which required
adjustment when the time came.  The crew was
mostly from the West Country, men of Devon with
one or two traditions to uphold in the matter of brave
adventure.  It also included Welshmen and Irish
with a pretty taste for a fight, and a few Scots, of the
dour type, hard to frighten.  They were picked from
the Royal Navy, Fleet and Royal Reserves—merchant
seamen and fishermen the last, many of whom
had formed a nodding acquaintance with Death long
before they received this invitation to a closer
intimacy.  Their ages ranged between 17 and 52.
</p>
<p>
They sailed from Queenstown under the Red Ensign;
but before they left some of the crew trudged,
as pilgrims to a shrine, and stood awhile among the
mounds in that pathetic God's acre where the women
and children of the <i>Lusitania</i> rest.  They were then
but freshly turned, those mounds, in their eloquent
diversity of lengths, and men had not begun to
forget....
</p>
<p>
For five weary months they endured the winter
gales of the Atlantic, wallowing to and fro along the
trade routes, outwardly a scallywag tramp, but
behind her untidy bulwarks observing, with certain
necessary modifications, the discipline and customs
of his Majesty's Navy.  With paint-pot and sail-cloth
they improved the ship's disguise from time to time,
and wiled away the heart-breaking monotony of the
days by inventing fresh devices to conceal their
character.
</p>
<p>
The ship's steward's assistant, when not engaged
upon his office as "dusty boy," was ordered
to don female attire over his uniform and recline in
a prominent position on the poop in a deck-chair.
This allurement was calculated to prove an irresistible
bait.  The Navigator, whose action station was the
abandonment of the ship in the rôle of distracted
Master, fashioned the effigy of a stuffed parrot and
fastened it inside a cage which he proposed to take
away with him in the boat, thus heightening the
pathos of the scene and whetting the blood-lust of
the enemy....
</p>
<p>
From time to time watchful patrols swooped down
upon them, exchanged a few curt signals in the
commercial code, and bade them pass on their imaginary
occasions.  Once a Cruiser, less easily satisfied than
the remainder, bade the rusty-sided collier heave to,
and sent an officer to board her; he climbed inboard
at the head of armed men to find himself confronted,
in the person of the "Master," with a term-mate of
Britannia days and a grin he is not likely to forget.
Then, early one spring morning, when the daylight
was stealing out of grey skies across the Atlantic
waste, the track of a torpedo bubbled across the bows
and passed ahead of the ship.  The moment for
which they had waited five weary months had come.
</p>
<p>
In accordance with her rôle of tramp steamer in the
early days of the War, the ship held steadily on her
way, observing the stars in their courses, but not
otherwise interested in the universe.  Inboard,
however, the alarm rang along the mess-decks and
saloons, and men crawled into hen-coops and
deck-houses to man the hidden guns.  A few minutes
later the submarine broke surface half a mile
astern of the ship, and fired a shot across her bows.
Whereupon the supposed collier stopped her engines,
and lay rolling in the trough of the seas with steam
pouring from her exhausts, while the crew, who had
rehearsed this moment to a perfection never yet
realised on the boards of legitimate drama, rushed to and
fro with every semblance of panic.  The Captain
danced from one end of the bridge to the other,
waving his arms and shouting; boats were turned out
and in again amid a deliberate confusion that brought
blushes to the cheeks of the ex-merchant seamen
called upon to play the part.
</p>
<p>
In the meantime the submarine had approached at
full speed to within about 700 yards, and, evidently
not satisfied with the speed at which the ship was
being abandoned, fired another shot, which pitched
50 yards short of the engine-room.  There was
apparently nothing further to be gained by prolonging the
performance for this impatient audience, and the
Lieutenant-Commander on the bridge, cap in hand,
and breathless with his pantomimic exertions, blew a
shrill blast on his whistle.  Simultaneously the White
Ensign fluttered to the masthead, deck-houses and
screens clattered down, and three minutes later the
submarine sank under a rain of shells and Maxim
bullets.  As she disappeared beneath the surface the
avenger reached the spot, and dropped a depth-charge
over her.  A moment after the explosion the submarine
appeared in a perpendicular position alongside
the ship, denting the bilge-keel as she rolled
drunkenly among the waves.  The after gun put five
more rounds into the shattered hull at point-blank
range, and, as she sank for the last time, two more
depth-charges were dropped to speed her passing.
</p>
<p>
The Lieutenant-Commander in command had personally
been superintending the administering of the
<i>coup de grâce</i> from the stern, and, as he turned to
make his way forward to the bridge, for a few brief
moments the bonds of naval discipline relaxed.  His
men surged round him in a wildly cheering throng,
struggling to be the first to wring him by the hand.
They then mustered in the saloon, standing
bare-headed while their Captain read the Prayers of
Thanksgiving for Victory, and called for three cheers
for his Majesty the King.  They cheered as only
men can cheer in the first exultant flush of victory.
But as the vessel gathered way and resumed her grim
quest, each man realised, deep down in his heart, that
far sterner ordeals lay ahead.
</p>
<p><br/>
<br/>
<br/>
</p>
<p><a id="chap0202"></a></p>
<h3 id="pgepubid00007">
2
<br/>
<br/>
ORDEAL BY FIRE
</h3>
<p>
Because man is mortal, not infallible, and Fortune at
her brightest a fickle jade, it was inevitable that sooner
or later a day must come when a crippled German
submarine would submerge beneath a hail of shells,
miraculously succeed in patching up her damaged
hull, and, under cover of darkness, crawl back to
port.  Word would then go out from Wilhelmshaven
of a British man-of-war disguised as a lumbering
tramp, with such and such a marking on her funnel,
with stumpy masts and rusty deck-houses, who carried
guns concealed in wheel-house and hen-coops, whose
bulwarks collapsed, and whose bridge screens masked
quick-firers and desperate men.  German submarines
would be warned that to approach such a vessel was
to enter a death-trap, unless every precaution was first
taken to ensure she had been abandoned.
</p>
<p>
Such a day came in due course; misty, windless,
with the aftermath of a great storm rolling
eastward beneath a sullen swell.  A vessel with the
outward appearance of a merchantman (the fruits
of whose labours for the past six months had
doubtless perplexed that section of the Wilhelmshaven
bureaucracy concerned with the non-return of
U-boats), sighted towards evening the periscope and
conning-tower of a submarine a mile away on her
beam.
</p>
<p>
The figure on the bridge of the tramp, who carried,
among other papers in his charge, his commission
as a Commander of the Royal Navy, laughed as
Drake might have laughed when the sails of a
Spanish galleon broke the horizon.  A tangle of
flags appeared at the periscope of the submarine,
and the tramp stopped obediently, blowing off
steam in great clouds.  Her Commander turned over
the pages of the International Signal Code, smiling
still.  "Hoist: 'Cannot understand your signal,'"
he said to the signalman, "I want to waste a few
minutes," and moved to the engine-room voice-pipe.
Obedient to his directions, the screws furtively jogged
ahead under cover of the escaping steam, edging the
steamer towards the watching enemy.  The latter,
however, promptly manned her foremost gun, turned,
and slowly steamed towards them; she opened fire at
a range of half a mile, the shell passing over the
funnel of the disguised man-of-war.
</p>
<p>
In the tense excitement of that moment, when
men's nerves and faculties were stretched like
banjo-strings, the report of the submarine's gun rang loud
through the still air.  One of the man-of-war's
gun-layers, lying concealed within his collapsible
deckhouse, heard the report, and, thinking that the ship
herself had opened fire without the customary
warning gongs, flung down the screens which masked his
weapon. Any further attempt at concealment was
useless.  The fire-gongs rang furiously at every gun
position, the White Ensign was triced up to the mast-head
in the twinkling of an eye, and the action started.
After the first few hits the submarine lay motionless,
with her bows submerged and her stern in the air for
upwards of five minutes, while shells burst all about
her.  The heavy swell made shooting difficult, but
eventually she sank in a great commotion of the water
and dense clouds of vapour that hung over the surface
for some minutes.  Two depth-charges were dropped
over her, and if ever men had cause for modest
self-congratulation on having ridded the seas of yet
another scourge, it would seem that the officers and
crew of The King's Ship might have laid claim to
their share.  Yet, by ways unknown and incredible, it
was claimed by the enemy that the submarine contrived
to return, with shot-holes plugged, to tell the tale.
</p>
<p>
Once the cat was out of the bag, it was obvious
that in the future the enemy would not rise to
the surface until his torpedo had found its mark,
and it became part of this grim game of bluff
for the victim to ensure that she was hit.  Then,
when the "panic party" had abandoned the ship,
the remainder must wait concealed and unresponsive
beside their hidden guns, while the submarine
rose to the surface and either closed within
range or shelled them with sufficient thoroughness to
convince him—who judged endurance and self-control
by no mean standards—that the limit of human
courage had been reached; that there could be no one
concealed on board, and that he might with safety
approach to loot and burn.  Now this, as Mr. Kipling
would put it, "was a damned tough bullet to
chew."  They were no demi-gods, nor yet fanatics,
these three-score or so sailor-men.  They were just
ordinary human beings, with the average man's
partiality for life and a whole skin, and the love of
wife and bairn or sweetheart plucking at the heart-strings
of most of them.  But they shared what is not
given to all men in this world of human frailty—a
whole-souled confidence in a fellow-man, which
would have carried them at his lightest nod through
the gates of hell.
</p>
<p>
Under his command, then, they sailed with a cargo
of timber in each hold, and in due course, about 9.45
one morning, a torpedo was seen approaching the
starboard beam.  Observing his rôle as Master of a
careless tramp, with poor look-outs, the Commander held
on his course.  At the last moment, however, the helm
was imperceptibly altered to ensure the ship being
struck abaft the engine-room, where the torpedo might
do least damage.  Those whom fate has afforded the
opportunity of studying the trail of an approaching
torpedo will, if they recall their sensations, appreciate
to some extent the iron nerve requisite to such a
manœuvre.  The torpedo burst abreast No. 3 hold,
hurling a wall of water and wreckage to the height of
the mast, and blowing a hole in the ship's side 40 feet
wide.  Half-stunned and deafened by the concussion,
the Commander raised himself on his hands and knees,
where he had been flung, and shouted to the Navigator:
"They've got us this time!"  The Navigator, who
was inside the chart-house, thrust his head out for a
moment, moistening a lead pencil with his lips.  "I
reckon I've got time to finish working out this sight,
sir," he replied with a grin, and withdrew his head.
</p>
<p>
The alarm-gongs had already sent the guns' crews
to their invisible guns, and immediately after the
explosion "Panic stations" was ordered, followed in
due course by "Abandon ship."  The Navigator,
having finished his "sight," and now acting as
"Master," abandoned ship with the "panic party."  No
sooner had the boats been lowered and shoved off
from the ship's side, however, than the Chief Engineer
rang up from below and reported that the after bulkhead
had gone and that the engine-room was filling
fast.  Peering, on all fours, through a slit in the
bridge-screen, waiting for the inevitable periscope to
appear, the Commander bade him hold on as long
as he could and keep enough steam to work the
pumps; when the water had extinguished the fires,
and then only, the engines were abandoned and the
staff remained concealed.  This they did, crawling
eventually on to the cylinders to escape from the
rising flood.
</p>
<p>
Shortly after the torpedo struck the ship the
periscope of a submarine broke the surface a couple of
hundred yards distant, evidently watching proceedings
with a deliberate, cautious scrutiny.  Moving
slowly through the water, like the fin of a waiting
shark, the sinister object came gradually down the
ship's side, within five yards of the breathless
boats, and not ten yards from where the
Commander lay beside the voice-pipes that
connected him with the Assistant-Paymaster, R.N.R.,
who, concealed in the gun control position, was
awaiting the order to open fire.  From the altitude of the
bridge, the submerged whale-back hull was plainly
visible to the figure crouched behind the bridge-screens,
and the temptation to yield to the impulse of
the moment, to open fire and end the suspense, shook
even his iron nerves.  A lucky shot might pierce the
lead-grey shadow that moved 15 feet beneath the
surface; but water plays strange tricks with projectiles,
deflecting them at unexpected ricochets, at angles
no man can foretell; moreover, the submarine was in
diving trim.  The odds against a broadside
overwhelming her before she could plunge into the depths
and escape were too great.  So the Commander waited,
with self-control that was almost superhuman, and,
prone beside their guns, unseeing and unseen, his
men waited too.
</p>
<p>
The ship had then sunk by the stern until it was
awash, and the crew of the gun masked by the wheelhouse
were crouched up to their knees in water.  A
black cat, the ship's mascot, that had been blown off
the forecastle by the explosion of the torpedo, swam
aft and in over the stern, whose counter rose normally
20 feet above the surface.  Still the periscope
continued its unhurried observation; it travelled past
the ship, across the bow, and then slowly moved
away, as if content that the task was done.  For
the space of nearly a minute bitter disappointment
and mortification rose in the Commander's
heart.  His ship had been torpedoed and was
sinking.  Their quarry had all but been within
their grasp, and was now going to escape unscathed.
Then, when hope was flickering to extinction, the
submarine rose to the surface 300 yards on the port bow,
and came slowly back towards the ship.
</p>
<p>
Up to this juncture, although the ship was settling
deeper every moment, the Commander had purposely
refrained from summoning assistance by wireless, lest
interruption should come before his grim work was
done.  Now, however, he saw at one quick glance that
the Lord had indeed "placed the enemy upon his lee
bow," and the rest was only a matter of a few bloody
moments.  Accordingly he gave orders for an urgent
wireless signal to be sent out forthwith summoning
assistance, and waited until the submarine was on a
line when all his guns would bear.  She reached the
desired spot at the moment when the German Commander
was complacently emerging from the conning-tower;
up went the White Ensign, and the first shot
beheaded him; he dropped back into the interior of
the submarine, and his wholly unexpected reappearance
imparted a shock of surprise to the remainder of
the inmates from which they never recovered.  The
submarine lay motionless as a dead whale, while the
avenging broadside shattered the hull, and the
grizzled pensioner inside a hen-coop scientifically
raked her deck with a Maxim to prevent her gun from
being manned.  She finally sank with her conning-tower
open and the crew pouring shrieking out of the
hatchway.
</p>
<p>
From the swirling vortex of oil and blood and air
bubbles in which the majority vanished, two dazed
prisoners were rescued by the exultant "panic party"
in the boats, and brought back to the ship.  Once on
board, however, the imperious necessities of the
moment overwhelmed even the elation of victory.
Bulkheads were shored in all compartments still accessible,
confidential documents destroyed in anticipation
of the worst, and then all but the Commander and a
handful of men took to the boats and awaited succour.
It came at noon in the guise of a congratulatory and
businesslike Destroyer, and was augmented later by a
couple of Sloops.  By 5 P.M. the water had ceased to
gain and the ship was in tow, heading for port; there
she arrived, and was safely beached after dark the
following day.
</p>
<p>
Thus her crew, emerging triumphant from the
ordeal, added at the last a feat of seamanship which
saved the ship.  It required no great power of
imagination to foretell what lay ahead; yet, when the time
came for a fresh venture under the command of the
man who had brought them victorious through the
ordeals that were past, they sailed with light hearts
and unafraid.  As if for a pledge of that devotion,
he wore thenceforward, on the left breast of his
ancient monkey-jacket, the scrap of ribbon which
it is the King's pleasure men shall wear "For
Valour."
</p>
<p><br/>
<br/>
<br/>
</p>
<p><a id="chap0203"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4135519329222943696_73819-h-0.htm.vue?2e5f6bf6